<template>
  <v-container v-if="this.zamawiajacy" class="page">
    <table>
      <thead>
        <tr>
          <td>
            <div
              class="cointainer caption"
              style="margin-top: 0px; margin-bottom: 10px"
            >
              <div class="left-cointainer">
                <img
                  height="50"
                  class="mt-1"
                  contain
                  src="/static/img/logo-tutore-small.svg"
                />
              </div>
            </div>
          </td>

          <td>
            <div class="right-cointainer">
              Tutore Poland Sp. z o.o.<br />
              ul. Piotrkowska 157A, 90-440 Łódź<br />
              NIP: 7272812193
            </div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="polish">
            <p align="center" style="margin-top: 20px">
              <strong>Umowa zlecenie nr {{ shortNrUmowy() }}</strong>
            </p>
            <p>Zawarta w Łodzi pomiędzy:</p>
            <p><strong>Zleceniodawcą:</strong></p>
            <p>
              <strong>Tutore Poland Sp. z o.o.</strong>, z siedzibą w Łodzi przy
              ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do Rejestru
              Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd
              Rejonowy dla Łodzi-Śródmieścia w Łodzi, XX Wydział Krajowego
              Rejestru Sądowego pod nr KRS: 0000670834, NIP: 727-28-12-193,
              REGON: 366891567, reprezentowaną przez:
            </p>
            <p>
              <strong>{{ zamawiajacy }}</strong
              >,
            </p>
            <p>a</p>

            <strong>Zleceniobiorcą:</strong>
            <br />
            Imię i nazwisko: {{ imieNazwisko }}
            <br />
            Pesel: {{ pesel }}
            <br />
            Adres: {{ zamieszkany }}
            <br />
            <br />

            <p align="center" style="margin-bottom: 0px">
              <strong>§ 1 Przedmiot umowy</strong>
            </p>
            <p style="margin-bottom: 0px">
              Zleceniodawca zleca, a Zleceniobiorca podejmuje się wykonywania za
              wynagrodzeniem na rzecz Zleceniodawcy takich czynności jak:
            </p>
            <ol>
              <li>
                rzetelne przygotowanie i prowadzenie zajęć zdalnych dla
                wszystkich uczestników kursów organizowanych przez Zleceniodawcę
                zgodnie z programem edukacyjnym szkoły Tutore Poland oraz
                harmonogramem zajęć. Harmonogram może mieć formę pliku
                elektronicznego;
              </li>
              <li>
                rzetelne prowadzenie dokumentacji potwierdzającej realizację
                zajęć, zawierającej w szczególności: dzienniki zajęć, listy
                obecności, dokumentację dotyczącą ewaluacji uczniów,
                sprawozdania z realizacji zajęć - w formie ustalonej przez
                Zleceniodawcę;
              </li>
              <li>
                terminowe wykonywanie wszystkich wytycznych organizacyjnych
                Zleceniodawcy w terminach przez niego określonych;
              </li>
              <li>prowadzenie zajęć odrobieniowych;</li>
              <li>
                dbanie o należyty stan mienia Zleceniodawcy oraz o porządek i
                ład w miejscu wykonywania zlecenia;
              </li>
              <li>
                współpraca z osobami wyznaczonymi przez Zleceniodawcę, przy czym
                Zleceniobiorca zobowiązany jest do regularnego i niezwłocznego
                (najpóźniej na koniec każdego dnia roboczego) odczytywania
                wiadomości wysyłanych przez te osoby poprzez pocztę e-mail,
                wiadomości sms lub poprzez komunikatory internetowe i w razie
                potrzeby jak najszybszego udzielenia odpowiedzi na informacje, w
                tym szczególnie:
                <ol type="a">
                  <li>
                    przekazywanie niezbędnych informacji w zakresie określonym w
                    danej sytuacji,
                  </li>
                  <li>
                    udział w zebraniach, rozmowach wizytacyjnych i ewaluacjach;
                  </li>
                </ol>
              </li>
              <li>
                współpraca z rodzicami uczniów, w tym szczególnie udzielanie
                niezbędnych informacji dotyczących usługi (np. przekazywanie
                prac domowych, sprawdzanie i przekazywanie raportów z postępów
                uczniów);
              </li>
              <li>inne zadania i projekty zlecone przez Zleceniodawcę.</li>
            </ol>
            <p>
              Celem zapewnienia warunków do wykonania niniejszej umowy,
              Zleceniodawca zobowiązuje się do udostępnienia wszystkich
              niezbędnych materiałów dydaktycznych, takich jak panele
              edukacyjne, grafiki do prezentacji oraz indywidualnego konta w
              systemie do nauki online. Powyższe nie obejmuje sprzętu
              elektronicznego (komputer, sprzęt nagłaśniający itp.), które
              Zleceniobiorca zobowiązany jest zorganizować na własny koszt.
            </p>
            <br />

            <p align="center" style="margin-bottom: 0px; margin-top: 40px">
              <strong>§ 2 Wykonywanie umowy</strong>
            </p>
            <ol>
              <li>
                Zleceniobiorca zobowiązuje się wykonywać przedmiot niniejszej
                umowy z należytą starannością.
              </li>
              <li>
                Wykonanie przedmiotu umowy wskazanego w § 1 odbywać się będzie
                online za pośrednictwem platform udostępnionych przez
                Zleceniodawcę lub w formule stacjonarnej w wybranej placówce
                Zleceniodawcy. Forma prowadzenia zajęć określona zostanie w
                harmonogramie zajęć. Zleceniodawca umożliwi Zleceniobiorcy
                korzystanie z platform niezbędnych do prowadzenia zajęć. Strony
                ustalają, iż za jednostkę obliczeniową przyjmuje się 60 minut
                zajęć według ustalonego harmonogramu.
              </li>
              <li>
                Łączny wymiar godzin dydaktycznych do wykonania będzie określony
                w harmonogramie każdorazowo przez Zleceniodawcę z wyprzedzeniem
                i podsumowany na koniec każdego miesiąca kalendarzowego.
              </li>
              <li>
                Strony dopuszczają zmianę dat i godzin zajęć określonych w
                harmonogramie wyłącznie za obopólną zgodą.
              </li>
              <li>
                Zleceniobiorca będzie wykonywać usługi objęte niniejszą umową w
                warunkach całkowitej niezależności od Zleceniodawcy. W
                szczególności Zleceniodawca nie będzie uprawniony do wykonywania
                wobec Zleceniobiorcy jakichkolwiek praw kierowniczych, nie
                ingerując w organizację i/lub dyscyplinę pracy Zleceniobiorcy.
                Wszelkie problemy techniczne lub metodologiczne dotyczące
                całości powierzonych Zleceniobiorcy czynności będą rozwiązywane
                przez wspólne porozumienie Stron, z poszanowaniem niezależności
                działalności zawodowej prowadzonej przez Zleceniobiorcę.
              </li>
              <li>
                Zleceniobiorca nie może powierzyć wykonania przedmiotu
                niniejszej umowy osobie trzeciej.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px; margin-top: 10px">
              <strong>§ 3 Obowiązek informacyjny</strong>
            </p>
            <ol>
              <li>
                Zleceniodawca zobowiązany jest dostarczać Zleceniobiorcy
                wszelkich informacji niezbędnych do realizacji przez niego
                przedmiotu umowy.
              </li>
              <li>
                Zleceniobiorca zobowiązany jest udzielać Zleceniodawcy
                potrzebnych informacji o przebiegu realizacji przez niego
                przedmiotu umowy.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px; margin-top: 5px">
              <strong>§ 4 Absencje i powiadamianie o nich</strong>
            </p>
            <ol>
              <li>
                W przypadku niemożności przeprowadzenia zajęć określonych w § 1
                w terminach określonych w harmonogramie z przyczyn leżących po
                stronie Zleceniobiorcy zobowiązuje się on do niezwłocznego
                powiadomienia Zleceniodawcy o zaistniałym fakcie, nie później
                niż 7 dni przed planowanymi zajęciami. W takim przypadku
                Zleceniodawca może wyznaczyć osobę, która zastąpi Zleceniobiorcę
                w wykonaniu zlecenia opisanego w niniejszej umowie.
              </li>
              <li>
                W przypadku nagłej niedyspozycji wynikającej z choroby lub złego
                stanu zdrowia, które wystąpiło nagle, Zleceniobiorca może nie
                zachować 7-dniowego okresu powiadomienia o niemożności
                wykonywania zlecenia. Zleceniobiorca zobowiązuje się
                niezwłocznie, nie później niż 4 godziny po wystąpieniu zdarzenia
                i minimalnie 2 godziny przed rozpoczęciem planowanych zajęć
                powiadomić o takiej sytuacji Zleceniodawcę.
              </li>
              <li>
                W przypadku nagłej niedyspozycji wynikającej z choroby lub złego
                stanu zdrowia, które wystąpiło nagle, Zleceniobiorca może nie
                zachować 7-dniowego okresu powiadomienia o niemożności
                wykonywania zlecenia, jednak zobowiązany jest do poinformowania
                Zleceniodawcy niezwłocznie po zaistnieniu takiego zdarzenia.
                Zleceniobiorca potwierdza to, na podstawie e-zwolnienia
                lekarskiego, które wpłynie na profil Zleceniodawcy w portalu PUE
                ZUS.
              </li>
              <li>
                W przypadku nie przeprowadzenia zajęć w terminie wynikającym z
                harmonogramu i nie powiadomienia o tym fakcie Zleceniodawcy z
                wyprzedzeniem nie mniejszym niż 7 dni przed planowanymi
                zajęciami, Zleceniodawca może rozwiązać umowę ze skutkiem
                natychmiastowym bez zachowania okresu wypowiedzenia. W takim
                przypadku, niezależnie od możliwości wypowiedzenia umowy,
                Zleceniodawca może ponadto dochodzić kary umownej w wysokości 5
                000 zł (słownie: pięć tysięcy złotych) od Zleceniobiorcy za
                poniesione straty. Zleceniodawca może także dochodzić
                odszkodowania przenoszącego wartość zastrzeżonej kary umownej.
                Powyższy zapis nie dotyczy sytuacji losowych uniemożliwiających
                powiadomienie Zleceniodawcy o niemożliwości przeprowadzenia
                zajęć.
              </li>
              <li>
                W przypadku niemożności przeprowadzenia przez Zleceniobiorcę
                zajęć zaplanowanych według harmonogramu i niemożliwości
                znalezienia zastępstwa przez Zleceniodawcę, Zleceniobiorca
                zobowiązany jest do przeprowadzenia zajęć w ilości godzin równej
                nieodbytym zajęciom tzw. zajęcia odrobieniowe w innym terminie
                uzgodnionym pisemnie ze Zleceniodawcą, nie później niż 14 dni od
                planowanej daty zaplanowanych zajęć.
              </li>
            </ol>

            <p align="center" style="margin-bottom: 0px; margin-top: 10px">
              <strong>§ 5 Czas trwania umowy i okres wypowiedzenia</strong>
            </p>
            <ol>
              <li>
                Strony zawierają umowę od dnia
                {{ dataObowiazywaniaUmowyPolski() }} do dnia
                {{ dataKoncaUmowyPolski() }}.
              </li>
              <li>
                Strony mogą rozwiązać umowę z zachowaniem miesięcznego okresu
                wypowiedzenia, ze skutkiem prawnym na koniec następnego miesiąca
                kalendarzowego, po pisemnym przesłaniu informacji o
                wypowiedzeniu umowy (z zastrzeżeniem ust. 3 niniejszego
                paragrafu).
              </li>
              <li>
                Zleceniodawca ma prawo rozwiązać niniejszą umowę bez zachowania
                okresu wypowiedzenia w sytuacji braku możliwości powierzenia
                przedmiotu niniejszej umowy lub jeżeli Zleceniobiorca rażąco
                sprzeciwia się postanowieniom niniejszej umowy, przez co strony
                rozumieją w szczególności:
                <ol type="a">
                  <li>
                    zachowanie Zleceniobiorcy polegające na niewykonywaniu
                    obowiązków określonych w § 1, pomimo uprzedniego wezwania ze
                    strony Zleceniodawcy do zaniechania naruszeń,
                  </li>
                  <li>złamanie przez Zleceniobiorcę zakazu konkurencji,</li>
                  <li>ujawnienie przez Zleceniobiorcę Informacji Poufnych,</li>
                  <li>wszelkie inne naruszenia niniejszej umowy.</li>
                </ol>
              </li>
              <li>
                W przypadku rozwiązania umowy Zleceniobiorca zobowiązuje się do
                zwrotu materiałów udostępnionych na czas trwania umowy przez
                Zleceniodawcę w terminie do 14 dni od dnia rozwiązania lub
                wygaśnięcia umowy. W przypadku braku zwrotu materiałów w
                wyznaczonym terminie Zleceniodawca może nałożyć na
                Zleceniobiorcę karę finansową o wartości otrzymanych materiałów.
                Dodatkowo Zleceniobiorca może zostać obciążony kosztami
                przesyłki.
              </li>
            </ol>

            <p align="center" style="margin-bottom: 0px; margin-top: 10px">
              <strong>§ 6 Wynagrodzenie</strong>
            </p>
            <ol>
              <li>
                Z tytułu prawidłowego wykonania czynności wymienionych w § 1
                Zleceniobiorca otrzyma wynagrodzenie wg poniższego zestawienia.
                Wynagrodzenie będzie uzależnione od ilości aktywnych kursantów
                (takich, którzy w danym okresie rozliczeniowym mają wiążącą
                umowę na świadczenie usług edukacyjnych ze Zleceniodawcą) w
                grupie i będzie rozliczane wg poniższych tabeli:
                <br />
                <div>
                  <span>Tabela 1: stawki za lekcje w kursach stałych</span>
                  <table
                    style="
                      border: 1px solid;
                      text-align: left;
                      font-size: 12px;
                      width: 100%;
                    "
                  >
                    <tbody>
                      <tr>
                        <td style="border: 1px solid; padding: 10px">
                          <b>Stawka brutto za 1 lekcję 60 minutową kursu</b>
                        </td>
                        <td style="border: 1px solid; padding: 10px">
                          <b
                            >Ilość aktywnych kursantów w grupie w miesiącu
                            rozliczeniowym
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid; padding: 10px">{{ stawka1 }} {{ stawka1 ? 'zł' : null }}</td>
                        <td style="border: 1px solid; padding: 10px">1</td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid; padding: 10px">{{ stawka2 }} {{ stawka2 ? 'zł' : null }}</td>
                        <td style="border: 1px solid; padding: 10px">2-5</td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid; padding: 10px">{{ stawka3 }} {{ stawka3 ? 'zł' : null }}</td>
                        <td style="border: 1px solid; padding: 10px">
                          6 i więcej
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <br />
                <br />
                <div>
                  <span>Tabela 2: stawki za lekcje pokazowe </span>
                  <table
                    style="
                      border: 1px solid;
                      text-align: left;
                      font-size: 12px;
                      width: 100%;
                    "
                  >
                    <tbody>
                      <tr>
                        <td style="border: 1px solid; padding: 10px">
                          <b>Stawka brutto za 1 lekcję pokazową</b>
                        </td>
                        <td style="border: 1px solid; padding: 10px">
                          <b>Tryb prowadzenia lekcji</b>
                        </td>
                        <td style="border: 1px solid; padding: 10px">
                          <b>Długość trwania lekcji</b>
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid; padding: 10px">30 zł</td>
                        <td style="border: 1px solid; padding: 10px">online</td>
                        <td style="border: 1px solid; padding: 10px">30 min</td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid; padding: 10px">60 zł</td>
                        <td style="border: 1px solid; padding: 10px">
                          stacjonarna
                        </td>
                        <td style="border: 1px solid; padding: 10px">60 min</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </li>
              <br />
              <li>
                Całkowite miesięczne wynagrodzenie będzie wynikać ze stawki
                godzinowej wynikającej z ust. 1 i 2 niniejszego paragrafu oraz
                liczby lekcji przeprowadzonych w danym miesiącu, w oparciu o
                zestawienie i dokumentację, o których mowa w ust. 4 niniejszego
                paragrafu. W przypadku, gdy jedna lekcja zgodnie z
                harmonogramem, trwa więcej bądź mniej niż 60 minut to stawka
                wynagrodzenia za jedną lekcję będzie proporcjonalnie obniżona
                bądź powiększona. Zleceniobiorcy nie przysługuje dodatkowe
                wynagrodzenie za dokonanie czynności dodatkowych związanych z
                przygotowaniem, organizacją i raportowaniem zajęć.
              </li>
              <li>
                Zleceniobiorca będzie uprawniony do dodatkowych 10,00 zł
                (słownie: dziesięć złotych) brutto doliczonych do stawki
                godzinowej (określonej zgodnie z tabelą z ust. 1 § 6) jeśli
                miejsce przeprowadzenia lekcji będzie oddalone o minimum 25 km
                od najbliższej jednostki stacjonarnej Szkoły Profi Lingua lub
                miejsca zamieszkania zleceniobiorcy (tylko jeśli odległość do
                szkoły jest większa niż do miejsca zamieszkania Zleceniobiorcy).
              </li>
              <li>
                Zleceniobiorca jest zobowiązany do przygotowania i przedłożenia
                Zleceniodawcy w formie elektronicznej:
                <ol type="a">
                  <li>
                    zestawienia liczby godzin przepracowanych w danym miesiącu,
                    wygenerowanego z narzędzi do ewidencjonowania godzin
                    udostępnionego przez Zleceniodawcę, najpóźniej w pierwszym
                    dniu roboczym następnego miesiąca.
                  </li>
                  <li>
                    prowadzonej dokumentacji potwierdzającej realizację zajęć w
                    danym miesiącu, w szczególności dzienników zajęć i list
                    obecności uczniów, najpóźniej do ostatniego dnia miesiąca,
                    za który Zleceniobiorcy przysługuje wynagrodzenie z tytułu
                    wykonania zlecenia.
                  </li>
                </ol>
              </li>
              <li>
                Zleceniodawca może obniżyć o kwotę do 15% wysokości
                wynagrodzenia brutto za dany miesiąc, w przypadku niestosowania
                się do zapisów zawartych w umowie w szczególności:
                niedotrzymywania podanej dyspozycyjności, spóźniania się na
                zajęcia, nie odpisywania na e-maile oraz nie odbierania
                telefonów od osób wskazanych do kontaktu przez Zleceniodawcę,
                uzasadnionych skarg rodziców na jakość prowadzonych lekcji,
                niewywiązywania się z obowiązku oceniania dzieci w ramach
                raportów, nie zachowywania zasad kultury osobistej na zajęciach
                oraz w kontakcie z osobami wskazanymi przez Zleceniodawcę,
                niewywiązywania się z wytycznych dotyczących programu i jakości
                prowadzonych zajęć edukacyjnych określonych przez Zleceniodawcę.
              </li>
              <li>
                Wynagrodzenie Zleceniobiorcy będzie płatne z dołu w cyklu
                miesięcznym do 15-tego każdego miesiąca, przelewem na numer
                konta bankowego wskazanego przez Zleceniobiorcę.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px; margin-top: 30px">
              <strong>§ 7 Premia</strong>
            </p>
            <ol>
              <li>
                Zleceniodawca może przyznać Zleceniobiorcy premię uznaniową w
                wysokości do 15% wynagrodzenia brutto, której przyznanie jest
                uzależnione od stopnia realizacji przydzielonych zadań
                indywidualnych. Zadania indywidualne na kolejny miesiąc będą
                przedstawiane z odpowiednim wyprzedzeniem.
              </li>
              <li>
                Dodatkowo Zleceniodawca może przyznać dodatkową premię uznaniową
                za inne cele niezwiązane z ust. 1 niniejszego paragrafu.
              </li>
              <li>
                Premia nie ma charakteru roszczeniowego, zaś jej przyznanie, jak
                i określenie jej wysokości należy do swobodnego uznania
                Zleceniodawcy.
              </li>
              <li>
                Wyliczenie i wypłata premii następuje w ciągu 15 dni od
                zakończenia miesięcznego okresu rozliczeniowego.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px; margin-top: 50px">
              <strong>§ 8 Informacje poufne</strong>
            </p>
            <ol>
              <li>
                Przez Informacje Poufne strony rozumieją wszelkie informacje
                przekazane Zleceniobiorcy przez Zleceniodawcę lub uzyskane przez
                Zleceniobiorcę w inny sposób w związku z wykonywaniem niniejszej
                umowy, obejmujące informacje techniczne, technologiczne,
                organizacyjne lub inne informacje posiadające wartość
                gospodarczą, które dotyczą Zleceniodawcy i jego działalności, a
                w szczególności materiały dydaktyczne wykorzystywane przez
                Zleceniodawcę, baza danych kontaktowych do Klientów
                Zleceniodawcy (w tym także klientów, którzy zakończyli
                współpracę ze Zleceniodawcą do 12 miesięcy po zakończeniu
                umowy), systemy komputerowe oraz pozostałe informacje uzyskiwane
                od Zleceniodawcy w trakcie wykonywania umowy.
              </li>
              <li>
                Zleceniobiorca zobowiązuje się, że Informacje Poufne uzyskane w
                ramach niniejszej umowy będą utrzymywane w tajemnicy przez
                Zleceniobiorcę i wykorzystywane wyłącznie do wykonania
                niniejszej umowy. Informacje Poufne nie będą wykorzystywane w
                innych celach ani nie będą ujawniane, czy udostępniane osobom
                trzecim, w całości lub w części. Zobowiązanie do zachowania
                poufności dotyczy Informacji Poufnych uzyskanych przez
                Zleceniobiorcę od Zleceniodawcy w formie pisemnej oraz
                ujawnionych Zleceniobiorcy ustnie, wizualnie, elektronicznie lub
                w inny sposób. Zleceniobiorca zobowiązuje się utrzymywać
                otrzymane Informacje Poufne w tajemnicy i nie ujawniać ich
                komukolwiek bez pisemnej zgody Zleceniodawcy.
              </li>
              <li>
                Zleceniobiorca, po zakończeniu współpracy Stron, bądź też, przed
                jej zakończeniem – na każde żądanie Zleceniodawcy - zobowiązany
                będzie zwrócić Zleceniodawcy w ciągu 3 dni wszelkie Informacje
                Poufne, wraz z dokumentacją i innymi nośnikami, na których
                zostały one utrwalone, jak również, kopiami dokumentacji lub
                nośników zawierających takie Informacje. Zleceniobiorca
                zobowiązuje się do usunięcia z pamięci komputerów oraz innych
                urządzeń wszystkich otrzymanych lub wykonanych materiałów w
                sposób uniemożliwiający ich odtworzenie oraz wykorzystywanie w
                przyszłości w jakiejkolwiek formie.
              </li>
              <li>
                W przypadku naruszenia przez Zleceniobiorcę postanowień ustępów
                poprzedzających, w szczególności, poprzez niezgodne z tą umową
                ujawnienie lub udostępnienie materiałów oraz Informacji
                Poufnych, Zleceniobiorca zobowiązany będzie do zapłaty na rzecz
                Zleceniodawcy kary umownej w wysokości 5 000,00 zł (słownie:
                pięć tysięcy złotych) za każde takie naruszenie. Kara taka
                płatna będzie w terminie 14 dni od daty złożenia przez
                Zleceniodawcę oświadczenia o obciążeniu Zleceniobiorcy karą
                umową.
              </li>
              <li>
                Jeżeli wysokość szkody lub utraconych korzyści Zleceniodawcy
                wynikających z naruszenia przez Zleceniobiorcę postanowień
                niniejszej umowy przewyższać będzie wysokość kary umownej
                wskazanej w ust. 4 niniejszego paragrafu, Zleceniodawca może
                dochodzić odszkodowania uzupełniającego na zasadach ogólnych
                wynikających z Kodeksu cywilnego.
              </li>
              <li>
                Za naruszenie zasad opisanych w niniejszej umowie, Zleceniodawca
                uznaje także każdorazowe wykorzystanie materiałów dydaktycznych
                Zleceniodawcy do prywatnych celów Zleceniobiorcy oraz do celów
                nauczania osób, które nie są Klientami Zleceniodawcy.
              </li>
              <li>
                Niezależnie od wygaśnięcia czy rozwiązania niniejszej umowy,
                zobowiązania Zleceniobiorcy zachowania w poufności Informacji
                Poufnych pozostają w mocy bezterminowo.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px; margin-top: 30px">
              <strong>§ 9 Zakaz konkurencji</strong>
            </p>
            <ol>
              <li>
                Za działalność konkurencyjną w rozumieniu niniejszego paragrafu
                Strony uznają: oferowanie lub świadczenie przez Zleceniobiorcę
                jakichkolwiek usług edukacyjnych w jakiejkolwiek formie wobec
                klientów Zleceniodawcy, którzy zawarli umowę ze Zleceniodawcą
                najpóźniej w dniu wygaśnięcia niniejszej umowy.
              </li>
              <li>
                Za działalność konkurencyjną uważa się również:
                <ol type="a">
                  <li>
                    świadczenie przez Zleceniobiorcę pracy na rzecz podmiotu
                    prowadzącego działalność konkurencyjną względem
                    Zleceniodawcy; świadczenie przez Zleceniobiorcę usług w
                    oparciu o jakąkolwiek umowę prawa cywilnego na rzecz
                    podmiotu prowadzącego działalność konkurencyjną względem
                    Zleceniodawcy,
                  </li>
                  <li>
                    prowadzenie przez Zleceniobiorcę przedsiębiorstwa
                    prowadzącego działalność konkurencyjną względem
                    Zleceniodawcy, także za pośrednictwem osoby trzeciej,
                  </li>
                  <li>
                    bycie wspólnikiem spółki prowadzącej działalność
                    konkurencyjną względem Zleceniodawcy,
                  </li>
                  <li>
                    zasiadanie przez Zleceniobiorcę w organach podmiotów
                    prowadzących działalność konkurencyjną wobec Zleceniodawcy,
                  </li>
                  <li>
                    występowanie w charakterze agenta, pełnomocnika lub
                    prokurenta osób prowadzących działalność konkurencyjną
                    względem Zleceniodawcy.
                  </li>
                </ol>
              </li>
              <li>
                Zleceniobiorca zobowiązuje się w czasie trwania współpracy
                opisanej niniejszą umową nie prowadzić działalności
                konkurencyjnej w trakcie trwania niniejszej umowy względem
                działalności Zleceniodawcy według definicji przedstawionej w
                ust. 1 niniejszego paragrafu.
              </li>
              <li>
                Jeżeli to Klient, który jest aktualnym Klientem Zleceniodawcy,
                sam złoży propozycję współpracy Zleceniobiorcy, Zleceniobiorca
                ma obowiązek poinformowania Klienta o ww. zakazie działalności
                konkurencyjnej i odmówienia podjęcia współpracy oraz jest
                zobligowany do poinformowania Zleceniodawcy o zaistniałej
                sytuacji.
              </li>
              <li>
                Zleceniodawca zastrzega sobie prawo do sprawdzenia względem
                Zleceniobiorcy, czy zapisy niniejszego paragrafu są należycie
                wykonywane przez Zleceniobiorcę.
              </li>
              <li>
                Za każdorazowe złamanie zakazu konkurencji, o którym mowa w
                niniejszej umowie, Zleceniodawca może naliczyć Zleceniobiorcy
                karę w wysokości 20 000,00 zł (słownie: dwadzieścia tysięcy
                złotych). W takim przypadku Zleceniodawca może dochodzić także
                odszkodowania przenoszącego wartość zastrzeżonej kary umownej.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px; margin-top: 10px">
              <strong
                >§ 10 Doręczenia i korespondencja, zgoda na wykorzystanie
                wizerunku, RODO</strong
              >
            </p>
            <ol>
              <li>
                Strony postanawiają, że o ile nie dojdzie do pisemnego
                powiadomienia o zmianie adresu do korespondencji wszelka
                korespondencja kierowana na adresy podane w oznaczeniu stron,
                uważa się za doręczone najpóźniej z datą drugiego awizo.
              </li>
              <li>
                Adresy poczty elektronicznej podane są w oznaczeniu stron. Pismo
                wysłane drogą elektroniczną uważa się za doręczone z chwilą, gdy
                druga strona miała możliwość zapoznania się z nim.
              </li>
              <li>
                Zleceniobiorca wyraża zgodę na wykorzystanie swojego wizerunku,
                zgodnie z załącznikiem do niniejszej umowy.
              </li>
              <li>
                Zleceniobiorca zobowiązany jest do stosowania się do przepisów
                Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z
                dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w
                związku z przetwarzaniem danych osobowych i w sprawie swobodnego
                przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (RODO)
                oraz Ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych
                (t.j. Dz. U. z 2019 r. poz. 1781 z późn. zm). Zleceniobiorca
                wyraża zgodę na przetwarzanie jego danych osobowych, zgodnie z
                klauzulą informacyjną stanowiącą załącznik do niniejszej umowy.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px; margin-top: 15px">
              <strong>§ 11 Spory i sąd właściwy</strong>
            </p>
            <p>
              Strony oświadczają, że dołożą wszelkich starań by spory wynikłe z
              niniejszej umowy rozwiązać polubownie. W przypadku sporów, które
              nie będą mogły zostać rozwiązane polubownie w ciągu 14 dni od daty
              otrzymania przez drugą stronę pisemnego wezwania do takiego
              polubownego rozwiązania, zostaną one poddane pod rozstrzygnięcie
              sądowi właściwemu ze względu na siedzibę Zleceniodawcy.
            </p>
            <br />

            <p align="center" style="margin-bottom: 0px">
              <strong>§ 12 Kompletność oraz zmiana umowy</strong>
            </p>
            <ol>
              <li>
                Niniejsza umowa rozwiązuje i zastępuje wszelkie inne
                dotychczasowe pisemne lub ustne ustalenia, porozumienia,
                uzgodnienia i umowy Stron w zakresie objętym jej treścią, które
                niniejszym tracą moc prawną.
              </li>
              <li>
                Strony oświadczają, że poza niniejszą umową nie istnieją między
                nimi żadne dodatkowe ustalenia czy porozumienia dotyczące
                przedmiotu niniejszej umowy.
              </li>
              <li>
                Wszelkie zmiany niniejszej umowy wymagają formy pisemnej pod
                rygorem nieważności.
              </li>
              <li>
                Rozwiązanie niniejszej umowy wymaga formy pisemnej pod rygorem
                nieważności.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px; margin-top: 20px">
              <strong>§ 13 Klauzula salwatoryjna</strong>
            </p>
            <p style="margin-bottom: 0px">
              Jeżeli którekolwiek z postanowień niniejszej umowy okaże się
              nieważne w całości lub w części, pozostałe postanowienia pozostają
              w mocy, Strony zaś zobowiązują się na wniosek którejkolwiek z nich
              do zastąpienia nieważnych postanowień postanowieniami, których moc
              prawna i skutek ekonomiczny są najbardziej zbliżone do postanowień
              zastępowanych.
            </p>
            <br />

            <p align="center" style="margin-bottom: 0px">
              <strong>§ 14 Prawo właściwe</strong>
            </p>
            <ol>
              <li>Niniejsza umowa podlega prawu polskiemu.</li>
              <li>
                W sprawach nieuregulowanych niniejszą umową zastosowanie mają
                właściwe przepisy prawa, w szczególności przepisy Kodeksu
                cywilnego.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px; margin-top: 20px">
              <strong>§ 15 Liczba egzemplarzy umowy</strong>
            </p>
            <p>
              Niniejsza umowa została sporządzona w dwóch jednobrzmiących
              egzemplarzach, po jednym dla każdej ze stron.
              <br />
            </p>
            <br />

            <div class="cointainer" style="margin-top: 96px">
              <div class="left-cointainer">
                <span style="margin-left: 0%">{{ zamawiajacy }}</span
                ><br />
                <span style="margin-left: 0%"
                  ><b>Podpis Zleceniodawcy/ Principal's signature</b></span
                >
              </div>
            </div>
            <br />

            <div style="margin-top: 5px; page-break-before: always">
              <p>
                <strong
                  >Załącznik nr 1. ZGODA NA WYKORZYSTANIE WIZERUNKU</strong
                >
              </p>
              <p>
                Niniejszym oświadczam, że udzielam Tutore Poland Sp. z o.o., z
                siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440, KRS
                0000670834, NIP: 727-28-12-193, REGON: 366891567, (dalej: Tutore
                Poland Sp. z o.o.) zgody, na nieodpłatne utrwalenie oraz
                nieograniczone czasowo i terytorialnie wielokrotne wykorzystanie
                i rozpowszechnianie mojego wizerunku w formie fotografii w
                związku z wykonywaniem umowy zlecenia w celu umieszczenia jej w
                firmowej stopce mailowej. Wizerunek będzie wykorzystywany
                wyłącznie na czas trwania umowy w formie zdjęcia w
                korespondencji mailowej wysyłanego w imieniu Zleceniodawcy.
              </p>
              <p>
                Jak również niniejszym oświadczam, że udzielam Tutore Poland Sp.
                z o.o. zgody, na nieodpłatne utrwalenie oraz nieograniczone
                czasowo i terytorialnie wielokrotne wykorzystanie i
                rozpowszechnianie mojego głosu lub wypowiedzi utrwalonych w
                trakcie wykonywania niniejszej umowy o świadczenie usług przy
                użyciu telefonów o połączeniu VoIP (Voice over Internet
                Protocol).
              </p>
              <p>
                Niniejsza zgoda obejmuje następujące pola eksploatacji:
                wykorzystanie, utrwalanie, obróbkę i powielanie wykonanych
                zdjęć/nagrań, obrót egzemplarzami, na których utrwalono mój
                wizerunek lub głos oraz na zwielokrotnianie wizerunku/głosu
                wszelkimi dostępnymi technikami i metodami, rozpowszechnianie
                oraz publikowanie, w materiałach służących działalności Tutore
                Poland w szczególności w materiałach szkoleniowych, edukacyjnych
                i promocyjnych w dowolnej formie.
              </p>
              <p>
                Tutore Poland Sp. z o.o. przysługuje wyłączne prawo decydowania
                o formie i czasie wykorzystywania mojego wizerunku, głosu,
                wypowiedzi w całości lub w postaci dowolnych fragmentów.
                Wizerunek może być użyty do różnego rodzaju form elektronicznego
                przetwarzania obrazu, kadrowania i kompozycji, bez obowiązku
                akceptacji produktu końcowego, lecz nie w formach obraźliwych
                lub ogólnie uznanych za nieetyczne.
              </p>
              <div style="page-break-before: always">
                <p><strong>Załącznik nr 2. KLAUZULA INFORMACYJNA</strong></p>
                <p>Klauzule informacyjne z art. 13 RODO</p>
                <p>
                  Zgodnie z art. 13 ust. 1 i 2 rozporządzenia Parlamentu
                  Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r.
                  w sprawie ochrony osób fizycznych w związku z przetwarzaniem
                  danych osobowych i w sprawie swobodnego przepływu takich
                  danych oraz uchylenia dyrektywy 95/46/WE (ogólne
                  rozporządzenie o ochronie danych) (Dz. Urz. UE L 119 z
                  04.05.2016, str. 1), dalej „RODO”, informuję, że:
                </p>
                <p style="margin-bottom: 10px">
                  Administratorem Pani/Pana danych osobowych jest Tutore Poland
                  Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A,
                  90-440, KRS 0000670834, zwany dalej: „ADO”.
                </p>
                <p style="margin-bottom: 10px">
                  Może Pan/Pani kontaktować się z ADO pisząc na adres: Tutore
                  Poland Sp. z o.o, ul. Piotrkowska 157A, 90-440, mail
                  kadry@tutore.eu oraz poprzez kontakt z Inspektorem Ochrony
                  Danych na adres e-mail: mlokaj@mlkancelaria.com
                </p>
                <p>ADO przetwarza dane osobowe w celu:</p>
                <ol type="a">
                  <li>nawiązania współpracy - Art. 6 ust. 1 lit. b, f RODO,</li>
                  <li>
                    zapewnienia kontaktu pomiędzy Stronami (adres e – mail, nr
                    telefonu) - Art. 6 ust. 1 lit. b, f RODO,
                  </li>
                  <li>
                    realizacji praw i obowiązków wynikających z umowy o
                    świadczenie usług - Art. 6 ust. 1 lit. b, c, f RODO,
                  </li>
                  <li>
                    prowadzenia rejestru korespondencji - Art. 6 ust. 1 lit. c,
                    f RODO,
                  </li>
                  <li>
                    ewidencji przebiegu współpracy (w tym realizacja płatności)
                    - Art. 6 ust. 1 lit. b, c RODO,
                  </li>
                  <li>
                    dochodzenia roszczeń i praw - Art. 6 ust. 1 lit. b, f RODO,
                  </li>
                  <li>
                    realizacji obowiązków podatkowych - Art. 6 ust. 1 lit. b, c
                    RODO,
                  </li>
                </ol>
                <br />
                <p style="margin-bottom: 10px">
                  Odbiorcami danych osobowych są podmioty, którym ADO powierzył
                  przetwarzanie danych osobowych, w szczególności: dostawcy
                  usług technicznych i organizacyjnych, dostawcy usług
                  księgowych, kadrowych, prawnych i doradczych, banki
                  (realizacja płatności), organy publiczne w ramach realizacji
                  obowiązków związanych z prowadzeniem działalności gospodarczej
                  przez ADO.
                </p>
                <p style="margin-bottom: 10px">
                  ADO nie przekazuje danych osobowych poza Europejski Obszar
                  Gospodarczy.
                </p>
                <p style="margin-bottom: 10px">
                  Dane osobowe przechowywane będą przez okres realizacji umowy,
                  a następnie przez okres wyznaczony przez powszechnie
                  obowiązujące przepisy prawa, w tym w szczególności:
                  dochodzenie roszczeń (okres przedawnienia roszczeń),
                  prowadzenie ksiąg rachunkowych i dokumentacji podatkowej (5
                  lat od końca roku kalendarzowego, w którym powstał obowiązek
                  podatkowy).
                </p>
                <p style="margin-bottom: 10px">
                  Osoba, której dane są przetwarzane ma prawo dostępu do swoich
                  danych oraz otrzymania ich kopii, prawo do sprostowania
                  (poprawiania) swoich danych, prawo do usunięcia danych, prawo
                  do cofnięcia zgody, prawo do ograniczenia przetwarzania, prawo
                  do bycia zapomnianym, prawo do sprzeciwu, prawo do
                  przenoszenia danych, prawo do wniesienia skargi do Urzędu
                  Ochrony Danych Osobowych.
                </p>
                <p style="margin-bottom: 10px">
                  Podanie przez Panią/Pana danych osobowych oraz zgoda na ich
                  przetwarzanie i rozpowszechnianie wizerunku jest dobrowolne,
                  ale stanowi warunek konieczny dla nawiązania współpracy i
                  ewentualnego zawarcia umowy w formie pisemnej oraz realizacji
                  praw i obowiązków przez ADO.
                </p>
                <p style="margin-bottom: 10px">
                  W ramach działalności ADO nie dochodzi do zautomatyzowanego
                  podejmowania decyzji, w tym profilowania, z wykorzystaniem
                  zebranych danych osobowych.
                </p>
                <p style="margin-bottom: 10px">
                  Zakres danych podlegający przetwarzaniu: imię i nazwisko,
                  adres mailowy, numer telefonu, wizerunek, PESEL.
                </p>
                <div style="float: right; margin-top: 20px">
                  <p style="margin-bottom: 10px">{{ imieNazwisko }}</p>
                  <p style="margin-bottom: 10px">
                    <b>Podpis Zleceniobiorcy</b>
                  </p>
                </div>
              </div>
            </div>

            <div style="page-break-before: always">
              <p style="margin-bottom: 10px">
                <strong>
                  Załącznik nr 3. Upoważnienie uzupełniające do przetwarzania
                  danych osobowych w zbiorze w wersji papierowej i
                  elektronicznej
                </strong>
              </p>
              <p class="p-margin">
                Na podstawie art. 29 Rozporządzenia Parlamentu Europejskiego i
                Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony
                osób fizycznych w związku z przetwarzaniem danych osobowych i w
                sprawie swobodnego przepływu takich danych oraz uchylenia
                dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych),
                dalej RODO, niniejszym:
              </p>
              <p class="p-margin">
                z dniem podpisania upoważnienia przez obie strony
              </p>
              <p class="p-margin">
                upoważniam Pana/Panią {{ imieNazwisko }} Zleceniobiorcę Tutore
                Poland Sp. z o.o.
              </p>
              <p class="p-margin">
                realizująca umowę zlecenie poprzez prowadzenie zajęć w dziale
                edukacji
              </p>
              <p class="p-margin">
                do przetwarzania danych osobowych zawartych w poniżej
                wymienionych zbiorach danych osobowych:
              </p>
              <ol type="a">
                <li>
                  w wersji elektronicznej:
                  <ul>
                    <li>
                      zbiór danych osobowych Klientów: rodziców (opiekunów
                      prawnych) dzieci, młodzieży i dorosłych korzystających z
                      usług oferowanych przez Tutore Poland – imię i nazwisko,
                      adres zamieszkania, telefon kontaktowy, adres e-mail,
                    </li>
                    <li>
                      zbiór danych osobowych Klientów: dzieci, młodzieży i
                      dorosłych korzystających z usług oferowanych przez Tutore
                      Poland– imię i nazwisko, adres zamieszkania, telefon
                      kontaktowy, adres e-mail.
                    </li>
                  </ul>
                </li>
              </ol>
              <p class="p-margin">
                w zakresie wglądu, wprowadzania, modyfikacji, usuwania i
                archiwizacji danych osobowych objętych wyżej wymienionymi
                zbiorami.
              </p>
              <p class="p-margin">
                Niniejsze upoważnienie nie upoważnia do udzielania dalszych
                upoważnień i wygasa z dniem ustania umowy zlecenia, a ponadto
                może być w każdym czasie zmienione lub odwołane.
              </p>
              <p>
                Zobowiązuję Pana/Panią do przetwarzania danych osobowych
                zawartych w ww. zbiorach danych osobowych w zakresie i w sposób
                wymagany do wypełnienia obowiązków służbowych względem
                Zleceniodawcy - Administratora Danych Osobowych. Zobowiązuję
                Pana/Panią do przetwarzania danych osobowych zgodnie z
                udzielonym upoważnieniem, rozporządzeniem Parlamentu
                Europejskiego i Rady (UE)2016/679 z 27 kwietnia 2016 r. w
                sprawie ochrony osób fizycznych w związku z przetwarzaniem
                danych osobowych i w sprawie swobodnego przepływu takich danych
                oraz uchylenia dyrektywy 95/46/WE ( Dz. Urz. UE L 119, s.1) oraz
                przepisami ustawy z dnia 10 maja 2018 r. o ochronie danych
                osobowych (Dz.U. z 2018 r. poz.1000) i obowiązującymi w Tutore
                Poland Sp. z o.o..wewnętrznymi regulacjami w sprawie ochrony
                danych osobowych.
                <br />
                Naruszenie ww. obowiązków może skutkować poniesieniem
                odpowiedzialności karnej oraz stanowi podstawę do rozwiązania
                umowy zlecenie.
              </p>

              <div class="container" style="page-break-before: always">
                <table
                  style="
                    border: 1px solid;
                    text-align: left;
                    font-size: 12px;
                    width: 100%;
                  "
                >
                  <tr>
                    <td id="oswiadczenie">
                      <p align="center" class="subheading">
                        <strong>OŚWIADCZENIE ZLECENIOBIORCY</strong>
                      </p>
                      <ol>
                        <li>
                          Ja niżej podpisany/a oświadczam, iż:
                          <ol type="a">
                            <li>
                              zapoznałem/am się z treścią i zakresem
                              upoważnienia i przyjmuję je do wiadomości,
                            </li>
                            <li>
                              treść upoważnienia jest dla mnie zrozumiała i
                              jasna, a wszelkie wątpliwości zostały mi
                              wyjaśnione przez osobę upoważnioną w sposób
                              wyczerpujący,
                            </li>
                            <li>
                              zobowiązuję się do przetwarzania danych osobowych
                              zawartych w ww. zbiorach danych osobowych w
                              zakresie i w sposób wymagany do wypełnienia
                              obowiązków służbowych względem Zleceniodawcy,
                            </li>
                            <li>
                              zobowiązuję się do przetwarzania danych osobowych
                              zgodnie z udzielonym upoważnieniem, przepisami
                              Rodo oraz wewnętrznymi procedurami obowiązującymi
                              u Zleceniodawcy, w tym Polityką Prywatności,
                            </li>
                            <li>
                              zobowiązuję się do zachowania w tajemnicy danych
                              osobowych, do których mam lub będę miał dostęp w
                              związku z wykonywaniem obowiązków na rzecz Tutore
                              Poland Sp. z o.o. oraz zachowania w tajemnicy
                              sposobów zabezpieczenia danych osobowych, również
                              po odwołaniu lub zmianie upoważnienia, a także po
                              zakończeniu trwania umowy zlecenie.
                            </li>
                          </ol>
                        </li>
                      </ol>
                      <div
                        class="right-cointainer"
                        style="float: right; margin-top: 20px"
                      >
                        <span style="font-size: 14px">{{ imieNazwisko }}</span>
                        <br />
                        <span>czytelny podpis Zleceniobiorcy</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>

              <p class="subheading p-margin" style="text-align: center">
                {{ zamawiajacy }}
                <br />
                w imieniu Administratora
              </p>
              <br />
              <p align="center">
                Niniejsze upoważnienie uchylone zostało w dniu rozwiązania umowy
                zlecenie.
              </p>
            </div>

            <div style="page-break-before: always">
              <p>
                <b
                  >Załącznik nr 4. Informacja o monitoringu zajęć on – line i
                  nagrywaniu szkoleń wewnętrznych on - line</b
                >
              </p>
              <br />
              Informujemy, iż Tutore Poland Sp. z o.o. korzysta z środków
              technicznych umożliwiających monitoring prowadzonych zajęć on –
              line oraz nagrywania szkoleń wewnętrznych on - line. Monitoringiem
              są objęte urządzenia rejestrujące obraz oraz dźwięk, z których
              korzysta użytkownik w celu realizacji zajęć online tj. platforma
              Clickmeeting bądź aplikacja Zoom, a w przypadku szkoleń
              wewnętrznych online aplikacja Zoom. Tutore Poland Sp. z o.o.
              stosuje monitoring w następujących celach: zapewnienia najwyższych
              standardów obsługi zajęć lekcyjnych realizowanych przez
              pracowników/zleceniobiorców, prawidłowości wykonywania
              powierzonych czynności oraz ewentualnego poprawienia jakości
              lekcji, zabezpieczenia interesów firmy w sytuacjach spornych z
              klientem (materiał dowodowy), a w przypadku szkoleń wewnętrznych
              on – line w celu zapewnienia możliwości udostępnienia nagrań nowym
              pracownikom/zleceniobiorcom. Informujemy, iż: system monitoringu
              audiowizualnego i dźwiękowego zajęć online składa się z systemu
              rejestrującego platformy Clickmeeting bądź Zoom oraz serwera, na
              którym są zapisywane zajęcia online, dostęp do zapisu nagrań zajęć
              online posiadają osoby upoważnione przez Zarząd Tutore Poland Sp.
              z o.o. tj. Manager Działu Call Center, Dyrektor ds. Zarządzania
              Procesami, Teamleader Działu Infolinii, osoby, które mają wgląd do
              zarejestrowanego obrazu mają świadomość odpowiedzialności za
              ochronę danych osobowych oraz posiadają stosowne upoważnienie
              wydane przez Administratora danych osobowych. W toku nagrania
              dochodzi do przetwarzania danych osobowych w postaci głosu,
              wizerunku oraz imienia i nazwiska pracownika/zleceniobiorcy
              prowadzącego zajęcia lub szkolenie. Administratorem danych
              osobowych uzyskanych w ramach monitoringu zajęć on – line i w toku
              nagrywania szkoleń wewnętrznych on - line jest Tutore Poland Sp. z
              o.o., który w związku z opisaną powyżej czynnością zamieszcza
              poniżej wymaganą klauzulę informacyjną dotyczącą przetwarzania
              danych osobowych.
            </div>

            <div style="margin-top: 40px; font-size: 10px">
              <p>
                <b
                  >Załącznik nr 5. INFORMACJA O PRZETWARZANIU DANYCH
                  OSOBOWYCH</b
                >
              </p>
              <ol>
                <li>
                  Informuję, że Administratorem danych osobowych Pani/Pana jako
                  Zleceniobiorcy jest Tutore Poland Sp. z o.o. z siedzibą przy
                  ul. Piotrkowska 157A, 90-440 Łódź, KRS:
                  0000670834, NIP: 7272812193, tel. 500 965 135, info@tutore.eu
                </li>
                <li>
                  Przedstawiając Pani/Panu niniejszą informację o przetwarzaniu
                  danych osobowych Administrator spełnia obowiązek prawny
                  wynikający z art. 15 ust. 1 Rozporządzenia Parlamentu
                  Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r.
                  w sprawie ochrony osób fizycznych w związku z przetwarzaniem
                  danych osobowych i w sprawie swobodnego przepływu takich
                  danych oraz uchylenia dyrektywy 95/46/WE (ogólne
                  rozporządzenie o ochronie danych), dalej RODO.
                </li>
                <li>
                  Administrator pozyskuje informacje o Pani/Panu w związku z
                  obowiązkiem ustawowym, co jest niezbędne do skutecznej
                  realizacji procesu współpracy. W zakresie danych osobowych nie
                  dotkniętych ustawowym warunkiem niezbędności – ich podanie
                  jest dobrowolne.
                </li>
                <li>
                  Pani/Pana dane osobowe przetwarzane są w następujących celach,
                  na następującej podstawie i w następującym okresie:
                  <ol type="a">
                    <li>
                      zawarcia oraz realizacji umowy cywilnoprawnej – w celu
                      realizacji obowiązku wynikającego z kodeksu cywilnego
                      (art. 6 ust. 1 lit. b, c, f RODO) – przez okres
                      współpracy,
                    </li>
                    <li>
                      wyliczenia i wypłaty wynagrodzenia – w celu realizacji
                      obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1
                      lit. c, art. 9 ust. 2 lit. b RODO) – przez okres
                      współpracy,
                    </li>
                    <li>
                      potrąceń z wynagrodzenia – w celu realizacji obowiązków w
                      zakresie egzekucji z wynagrodzenia wynikających z kodeksu
                      postępowania cywilnego, ustawy o postępowaniu egzekucyjnym
                      w administracji, ustawy o komornikach sądowych (art. 6
                      ust. 1 lit. c RODO) – przez okres wyznaczony przez
                      powszechnie obowiązujące przepisy prawa,
                    </li>
                    <li>
                      realizacji obowiązków podatkowych – w celu realizacji
                      obowiązków płatnika podatku dochodowego wynikających z
                      ordynacji podatkowej, ustawy o podatku dochodowym od osób
                      fizycznych i innych przepisów podatkowych (art. 6 ust. 1
                      lit. c RODO) – przez okres 5 lat od końca roku
                      kalendarzowego,
                    </li>
                    <li>
                      realizacji obowiązków wobec ZUS – w celu realizacji
                      obowiązków płatnika składek na ubezpieczenie społeczne i
                      zdrowotne wynikających z ustawy o emeryturach i rentach z
                      Funduszu Ubezpieczeń Społecznych, ustawy o systemie
                      ubezpieczeń społecznych oraz ustawy o świadczeniach opieki
                      zdrowotnej finansowanych ze środków publicznych (art. 6
                      ust. 1 lit. c, art. 9 ust. 2 lit b RODO) – przez okres 5
                      lat od końca roku kalendarzowego,
                    </li>
                    <li>
                      realizacji obowiązków księgowych – w celu realizacji
                      obowiązków wynikających z ustawy o rachunkowości,
                      ordynacji podatkowej oraz ustawy o podatku dochodowym od
                      osób prawnych (art. 6 ust. 1 lit. c RODO) – przez okres 5
                      lat od końca roku rozliczeniowego, w którym nastąpiło
                      zdarzenie,
                    </li>
                    <li>
                      bezpieczeństwa fizycznego budynków, pomieszczeń oraz
                      mienia Administratora – na podstawie prawnie uzasadnionego
                      interesu Administratora (art. 6 ust. 1 lit. f RODO) –
                      przez okres współpracy,
                    </li>
                    <li>
                      zapewnienia najwyższych standardów obsługi zajęć
                      lekcyjnych realizowanych przez Współpracowników za
                      pośrednictwem platformy ClickMeeting lub Zoom,
                      prawidłowości wykonywania powierzonych czynności oraz
                      ewentualnego poprawienia jakości lekcji, zabezpieczenia
                      interesów firmy w sytuacjach spornych z klientem (materiał
                      dowodowy) poprzez monitoring i nagrywanie kursów online –
                      na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1
                      lit. a RODO) – Wizerunek i głos Współpracownika będzie
                      przetwarzany przez okres 3 miesięcy. W przypadku, w którym
                      nagrania zarejestrowanych zajęć stanowią dowód w
                      postępowaniu prowadzonym na podstawie przepisów prawa lub
                      Administrator powziął wiadomość, iż mogą one stanowić
                      dowód w postępowaniu, termin ten ulega przedłużeniu do
                      czasu prawomocnego zakończenia postępowania. Po upływie
                      tych okresów nagrania zawierające dane osobowe, podlegają
                      zniszczeniu,
                    </li>
                    <li>
                      zapewnienia możliwości udostępnienia nagrań nowym
                      Pracownikom i Współpracownikom nagrywanie szkoleń online
                      prowadzonych za pomocą platformy Zoom – na podstawie
                      dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO)
                      - Wizerunek i głos Współpracownika będą przetwarzane do
                      czasu wycofania zgody. W razie wycofania zgody nagrania
                      zawierające dane osobowe, podlegają zniszczeniu,
                    </li>
                    <li>
                      zapewnienia najwyższych standardów jakości obsługi
                      klienta, w celu szkoleniowym – umożliwiającym poprawienie
                      jakości obsługi, zabezpieczenia interesów firmy w
                      sytuacjach spornych z klientem (materiał dowodowy),
                      zapewnienia bezpieczeństwa Współpracownikom w przypadku
                      zdarzeń niepożądanych i niebezpiecznych ze strony Klientów
                      (np. groźby karalne) poprzez monitoring rozmów
                      telefonicznych z Klientami Administratora – na podstawie
                      prawnie uzasadnionego interesu Administratora (art. 6 ust.
                      1 lit. f RODO) - przez okres do 3 miesięcy. W przypadku, w
                      którym nagrania zarejestrowanych rozmów telefonicznych
                      stanowią dowód w postępowaniu prowadzonym na podstawie
                      przepisów prawa lub Administrator powziął wiadomość, iż
                      mogą one stanowić dowód w postępowaniu, termin ten ulega
                      przedłużeniu do czasu prawomocnego zakończenia
                      postępowania. Po upływie tych okresów nagrania zawierające
                      dane osobowe, podlegają zniszczeniu,
                    </li>
                    <li>
                      tworzenia fotorelacji z obozów dla dzieci i młodzieży na
                      pendrive dla Klientów, fanpagu facebook i Witrynie
                      internetowej www.musicandmore.pl – na podstawie
                      dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO)
                      - Wizerunek i głos Współpracownika będą przetwarzane do
                      czasu wycofania zgody. W razie wycofania zgody nagrania
                      zawierające dane osobowe, podlegają zniszczeniu,
                    </li>
                    <li>
                      dochodzenia roszczeń lub obrony przed roszczeniami – na
                      podstawie prawnie uzasadnionego interesu Administratora
                      (art. 6 ust. 1 lit. f RODO) polegającego na występowaniu w
                      sprawach sądowych – w przypadku toczącego się postępowania
                      przez okres trwania postępowania do czasu jego
                      prawomocnego zakończenia oraz przez okres wyznaczony przez
                      powszechnie obowiązujące przepisy prawa.
                    </li>
                  </ol>
                </li>
                <li>
                  Odbiorcami Pani/Pana danych osobowych będą:
                  <ul>
                    <li>
                      organy administracji publicznej (np. Zakład Ubezpieczeń
                      Społecznych, Urzędy Skarbowe) – na mocy odpowiednich
                      przepisów prawa;
                    </li>
                    <li>
                      zakłady opieki zdrowotnej w celach związanych z medycyną
                      pracy;
                    </li>
                    <li>
                      podmioty zewnętrzne dostarczające i wspierające systemy
                      teleinformatyczne Zleceniodawcy (zarówno ogólną
                      infrastrukturę teleinformatyczną, pocztę elektroniczną,
                      jak i systemy informatyczne stosowane przez Zleceniodawcę
                      w celu obsługi kadrowo-finansowej lub obiegu dokumentów
                      związanych z zatrudnieniem) – na mocy stosownych umów
                      powierzenia przetwarzania danych osobowych oraz przy
                      zapewnieniu stosowania przez ww. podmioty adekwatnych
                      środków technicznych i organizacyjnych zapewniających
                      ochronę danych,
                    </li>
                    <li>biura księgowe:</li>
                    <li>
                      banki – w celu wypłaty wynagrodzeń i innych świadczeń
                      pieniężnych na rzecz Zleceniodawcy w przypadku ich wypłaty
                      za zgodą Zleceniobiorcy na rachunek bankowy;
                    </li>
                    <li>
                      kontrahenci – w celu umożliwienia kontrahentom
                      (potencjalnym oraz obecnym) kontaktu lub w celu bieżącej
                      realizacji zawartych umów, a związanych z zajmowanym przez
                      Zleceniobiorcę stanowiskiem pracy;
                    </li>
                    <li>
                      współpracownicy Zleceniodawcy, którzy świadczą usługi na
                      rzecz Tutore Poland Sp. z o.o., w celu umożliwienia
                      współpracownikom kontaktu ze Zleceniobiorcą,
                    </li>
                    <li>
                      podmioty świadczące dodatkowe usługi dla Zleceniobiorców,
                      wyłącznie w przypadku korzystania przez Zleceniobiorcę z
                      tych usług.
                    </li>
                    <li>instytucje ubezpieczeniowe</li>
                    <li>
                      organizacje administracji zagranicznej w krajach UE, w
                      których realizowana jest umowa (dotyczy realizacji umowy
                      za granicą)
                    </li>
                    <li>
                      podmioty szkoleniowe i realizujące obowiązki BHP (jeśli
                      nie ma komórki BHP u Zleceniodawcy)
                    </li>
                  </ul>
                </li>
                <li>
                  Ma Pani/Pan prawo do:
                  <ol type="a">
                    <li>
                      <strong>dostępu do danych</strong> — uzyskania od
                      Administratora potwierdzenia, czy przetwarzane są
                      Pani/Pana dane osobowe. Jeżeli dane są przetwarzane, jest
                      Pani/Pan uprawniona/y do uzyskania dostępu do nich (art.
                      15 RODO);
                    </li>
                    <li>
                      <strong>otrzymania kopii danych</strong> — uzyskania kopii
                      danych podlegających przetwarzaniu, przy czym pierwsza
                      kopia jest bezpłatna, a za kolejne kopie właściwy
                      Administrator może nałożyć opłatę w rozsądnej wysokości,
                      wynikającą z kosztów administracyjnych (art. 15 ust. 3
                      RODO);
                    </li>
                    <li>
                      <strong>sprostowania</strong> — żądania sprostowania
                      danych osobowych, które są nieprawidłowe, lub uzupełnienia
                      niekompletnych danych (art. 16 RODO);
                    </li>
                    <li>
                      <strong>usunięcia danych</strong> — żądania usunięcia
                      danych osobowych, jeżeli Administrator nie ma już podstawy
                      prawnej do ich przetwarzania lub dane nie są już niezbędne
                      do celów przetwarzania (art. 17 RODO);
                    </li>
                    <li>
                      <strong>ograniczenia przetwarzania</strong> — żądania
                      ograniczenia przetwarzania danych osobowych (art. 18
                      RODO), gdy:
                      <ol type="i">
                        <li>
                          kwestionuje Pani/Pan prawidłowość danych osobowych —
                          na okres pozwalający Administratorowi sprawdzić
                          prawidłowość tych danych,
                        </li>
                        <li>
                          przetwarzanie jest niezgodne z prawem, a sprzeciwia
                          się Pani/Pan ich usunięciu, żądając ograniczenia ich
                          wykorzystywania,
                        </li>
                        <li>
                          Administrator nie potrzebuje już tych danych, ale są
                          one Pani/Panu do ustalenia, dochodzenia lub obrony
                          roszczeń;
                        </li>
                        <li>
                          wniosła Pani/wniósł Pan sprzeciw wobec przetwarzania —
                          do czasu stwierdzenia, czy prawnie uzasadnione
                          podstawy po stronie Administratora są nadrzędne wobec
                          podstaw Pani/Pana sprzeciwu;
                        </li>
                      </ol>
                    </li>
                    <li>
                      <strong>przenoszenia danych</strong> — otrzymania w
                      ustrukturyzowanym, powszechnie używanym formacie nadającym
                      się do odczytu maszynowego danych osobowych Pani/Pana
                      dotyczących dostarczonych Administratorowi, oraz żądania
                      przesłania tych danych innemu Administratorowi, jeżeli
                      dane są przetwarzane na podstawie Pani/Pana zgody, lub
                      umowy z Panią/Panem zawartej oraz jeżeli dane są
                      przetwarzane w sposób zautomatyzowany (art. 20 RODO);
                    </li>
                    <li>
                      <strong>sprzeciwu</strong> — wniesienia sprzeciwu wobec
                      przetwarzania danych osobowych w prawnie uzasadnionych
                      celach Administratora, z przyczyn związanych z Pani/Pana
                      szczególną sytuacją, w tym wobec profilowania.
                      Administrator dokonuje oceny istnienia ważnych prawnie
                      uzasadnionych podstaw do przetwarzania, nadrzędnych wobec
                      Pani/Pana interesów, praw i wolności lub podstaw do
                      ustalenia, dochodzenia lub obrony roszczeń. Jeżeli zgodnie
                      z oceną Pani/Pana interesy będą ważniejsze od interesów
                      Administratora, Administrator będzie zobowiązany
                      zaprzestać przetwarzania danych w tych celach (art. 21
                      RODO);
                    </li>
                    <li>
                      <strong
                        >prawo wniesienia skargi do organu nadzorczego</strong
                      >
                      – Prezesa Urzędu Ochrony Danych Osobowych, gdy uzna
                      Pani/Pan, iż przetwarzanie danych osobowych Pani/Pana
                      dotyczących narusza przepisy. Skargi można składać w
                      formie:
                      <ul>
                        <li>
                          pisemnej na adres: ul. Stawki 2, 00-193 Warszawa,
                        </li>
                        <li>
                          elektronicznie za pośrednictwem platformy ePUAP.
                        </li>
                      </ul>
                    </li>
                  </ol>
                </li>
                <li>
                  W trakcie przetwarzania danych osobowych nie dochodzi do
                  wyłącznie zautomatyzowanego podejmowania decyzji ani do
                  profilowania, o których mowa w art. 22 ust. 1 i 4 RODO, co
                  oznacza, że żadne decyzje Pani/Pana dotyczące nie będą zapadać
                  automatycznie oraz że nie będą tworzone żadne profile
                  Pani/Pana dotyczące.
                </li>
                <li>
                  Ma Pani/Pan obowiązek informowania Zleceniodawcy o wszelkich
                  zmianach dotyczących Pani/Pana danych osobowych, przekazanych
                  Zleceniodawcy zgodnie z Umową.
                </li>
              </ol>
            </div>

            <div style="page-break-before: always">
              <div class="container">
                <table
                  style="
                    border: 1px solid;
                    text-align: left;
                    font-size: 12px;
                    width: 100%;
                  "
                >
                  <tr>
                    <td id="oswiadczenie">
                      <p align="center" class="subheading">
                        <strong>OŚWIADCZENIE ZLECENIOBIORCY</strong>
                      </p>
                      <ol>
                        <li>
                          Ja niżej podpisany/a oświadczam, iż:
                          <ol type="a">
                            <li>
                              zapoznałem/am się z Informacją o monitoringu zajęć
                              on – line i nagrywaniu szkoleń wewnętrznych on -
                              line oraz Klauzulą informacyjną i przyjmuję ją do
                              wiadomości,
                            </li>
                            <li>
                              treść Informacji i Klauzuli jest dla mnie
                              zrozumiała i jasna, a wszelkie wątpliwości zostały
                              mi wyjaśnione przez osobę upoważnioną w sposób
                              wyczerpujący.
                            </li>
                          </ol>
                        </li>
                        <li>
                          W sposób całkowicie dobrowolny, wyrażam zgodę na
                          przetwarzanie moich danych osobowych w celach
                          wskazanych w Informacji o monitoringu zajęć on – line
                          i nagrywaniu szkoleń wewnętrznych on – line.
                        </li>
                        <li>
                          Zostałem/am poinformowany/a, że moje dane osobowe
                          przetwarzane są na podstawie wyrażonej przeze mnie
                          dobrowolnej zgody oraz, że przysługuje mi prawo do jej
                          cofnięcia w każdym czasie, przy czym cofnięcie zgody
                          wywołuje skutki prawne od momentu jego złożenia i
                          będzie pozostawało bez wpływu na przetwarzanie moich
                          danych osobowych dla celów związanych z realizacją
                          badania przed złożeniem oświadczenia o cofnięciu
                          zgody.
                        </li>
                        <li>
                          W trybie art. 81 ust.1 ustawy o prawie autorskim i
                          prawach pokrewnych wyrażam zgodę na rozpowszechnianie
                          mojego wizerunku przez Tutore Poland Sp. z o.o. w
                          celach wskazanych w Informacji o monitoringu zajęć on
                          – line i nagrywaniu szkoleń wewnętrznych on – line.
                        </li>
                      </ol>
                      <div style="float: right; margin-top: 20px">
                        <span style="font-size: 14px">{{ imieNazwisko }}</span>
                        <br />
                        <span>czytelny podpis Zleceniobiorcy</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </td>

          <td class="english">
            <p align="center" style="margin-top: 17px">
              <strong>ORDER CONTRACT No {{ shortNrUmowy() }}</strong>
            </p>
            <p>Concluded in Łódź between:</p>
            <p><strong>The Principal:</strong></p>
            <p>
              Tutore Poland Sp. z o.o., based in Łódź at Piotrkowska Street
              157A, 90-440 Łódź, entered in the Register of Entrepreneurs of
              the National Court Register kept by the District Court for
              Łódź-Śródmieście in Łódź, XX Division of the National Court
              Register under the number KRS: 0000670834, NIP: 727-28-12- 193,
              REGON: 366891567, represented by:
            </p>
            <p>
              <strong>{{ zamawiajacyAngielski() }}</strong
              >,
            </p>
            <p>and</p>

            <strong>the Contractor</strong>
            <br />
            Mr./Ms. Name: {{ imieNazwisko }}
            <br />
            PESEL: {{ pesel }}
            <br />
            Address: {{ zamieszkany }}
            <br />
            <br />

            <p align="center" style="margin-bottom: 0px">
              <strong>§ 1 Subject matter of the agreement </strong>
            </p>
            <p style="margin-bottom: 0px">
              The Principal commissions and the Contractor undertakes to perform
              for the Principal's benefit, for remuneration, such activities as:
            </p>
            <ol>
              <li>
                reliable preparation and conduct of remote or on-site classes
                for all participants of courses organized by the Principal
                following the educational program indicated by the Principal and
                the schedule of classes. The schedule may be in the form of an
                electronic file;
              </li>
              <li>
                reliable maintenance of documentation confirming the realization
                of classes, including, in particular: course logs, attendance
                lists, documentation of students' evaluation, and reports on the
                realization of classes - in the form and at the dates
                established by the Principal;
              </li>
              <li>
                timely execution of all organizational guidelines of the
                Principal within the deadlines set by the Principal;
              </li>
              <li>conducting de-briefing classes;</li>
              <li>
                taking care of the proper condition of the Principal's property
                and neatness and order in the place of execution of the
                assignment;
              </li>
              <li>
                cooperating with the Principal's designees, whereby the
                Contractor shall regularly and promptly (at the end of each
                working day at the latest) read the messages sent by these
                persons via e-mail, SMS messages, or instant messaging and
                respond to the information as soon as possible if necessary,
                including in particular:
                <ol type="a">
                  <li>
                    providing necessary information to the extent specified in
                    the situation,
                  </li>
                  <li>
                    participating in meetings, visit interviews, and
                    evaluations;
                  </li>
                </ol>
              </li>
              <li>
                cooperation with students or, in the case of underage students,
                their parents or legal guardians, including, in particular,
                providing the necessary information regarding the service (e.g.,
                handing over homework, checking and submitting reports on
                students' progress) - participation in meetings or gatherings,
                within the strict deadlines set by the Principal;
              </li>
              <li>other tasks and projects ordered by the Principal.</li>
            </ol>
            <p>
              To ensure the conditions for the execution of this Agreement, the
              Principal undertakes to make available the teaching materials
              currently in his possession. The above does not include electronic
              equipment (computer, sound equipment, etc.), which the Contractor
              shall arrange at its own expense.
            </p>

            <p align="center" style="margin-bottom: 0px; margin-top: 10px">
              <strong>§ 2 Performance of the contract</strong>
            </p>
            <ol>
              <li>
                The Contractor undertakes to perform the subject of this
                agreement with due diligence.
              </li>
              <li>
                The performance of the subject of the agreement indicated in § 1
                will be carried out online via platforms provided by the
                Principal or in the stationary formula at the selected facility
                of the Principal. The form of conducting classes will be
                specified in the schedule of classes. Principal shall allow the
                Contractor to use the platforms necessary to conduct classes.
                The parties agree that 60 minutes of classes according to the
                agreed schedule shall be considered as the teaching unit.
              </li>
              <li>
                The total amount of teaching hours to be performed shall be
                specified in the schedule each time by the Principal in advance
                and summarized at the end of each calendar month.
              </li>
              <li>
                The parties shall allow changing the dates and hours of teaching
                specified in the schedule only by mutual agreement.
              </li>
              <li>
                The Contractor shall perform the services covered by this
                agreement under conditions of complete independence from the
                Principal. In particular, the Principal shall not be entitled to
                exercise any managerial rights over the Contractor without
                interfering with the organization and/or discipline of the
                Contractor's work. Any technical or methodological problems
                concerning the entirety of the activities entrusted to the
                Contractor shall be resolved by mutual agreement of the Parties,
                respecting the independence of the professional activities
                carried out by the Contractor.
              </li>
              <li>
                The Contractor shall not entrust the performance of the subject
                matter of this contract to a third party.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px; margin-top: 10px">
              <strong>§ 3 Information obligation </strong>
            </p>
            <ol>
              <li>
                The Principal shall provide the Contractor with all information
                necessary for the Contractor's performance of the subject matter
                of the contract.
              </li>
              <li>
                The Contractor shall provide the Principal with the necessary
                information on the course of its performance of the subject of
                the contract.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px; margin-top: 5px">
              <strong>§ 4 Absences and notification </strong>
            </p>
            <ol>
              <li>
                If the Contractor is unable to conduct the classes specified in
                § 1 on the dates specified in the schedule for reasons
                attributable to the Contractor, the Contractor agrees to
                immediately notify the Principal of this fact, no later than 7
                days before the scheduled classes. In such a case, the Principal
                may appoint a person to replace the Contractor in the
                performance of the assignment described in this agreement.
              </li>
              <li>
                In case of sudden indisposition due to illness or ill health,
                which occurred suddenly, the Contractor may not keep the 7-day
                notice period of inability to perform the assignment. The
                Contractor shall immediately, no later than 4 hours after the
                occurrence of the event and a minimum of 2 hours before the
                start of the scheduled classes, notify the Principal of such a
                situation.
              </li>
              <li>
                In the event of sudden indisposition due to illness or ill
                health that occurs suddenly, the Contractor may not observe the
                7-day notification period for inability to perform the
                assignment but shall inform the Principal immediately after the
                occurrence of such event. The Contractor shall confirm this,
                based on a medical e-certificate, which will be credited to the
                Principal's profile on the PUE ZUS portal.
              </li>
              <li>
                In the event of failure to conduct classes on the date specified
                in the schedule and failure to notify the Principal not less
                than 7 days in advance of the scheduled classes, the Principal
                may terminate the agreement with immediate effect without
                notice. In such a case, regardless of the possibility of
                termination, the Principal can also claim a contractual penalty
                of 5 000 PLN (in words: five thousand zlotys) from the
                Contractor for the losses incurred. Principal may also claim
                compensation exceeding the value of the reserved contractual
                penalty. The above provision does not apply to fortuitous
                situations that make it impossible to notify the Principal of
                the impossibility of carrying out the classes.
              </li>
              <li>
                In the event of the Contractor's inability to conduct scheduled
                classes and the Principal's inability to find a replacement, the
                Contractor shall be obliged to conduct classes in the number of
                hours equal to the missed classes, the so-called "de-briefing
                classes" on another date agreed in writing with the Principal,
                no later than 14 days from the scheduled date of the scheduled
                classes.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px; margin-top: 10px">
              <strong>§ 5 Duration of the contract and notice period</strong>
            </p>
            <ol>
              <li>
                The parties conclude the contract from the date
                {{ dataObowiazywaniaUmowyAngielski() }} until the date of
                {{ dataKoncaUmowyAngielski() }}
              </li>
              <li>
                The parties may terminate the agreement with one month's notice,
                with legal effect at the end of the next calendar month, after
                written notification of termination of the agreement (subject to
                paragraph 3 of this section).
              </li>
              <li>
                The Principal shall have the right to terminate this agreement
                without notice in the situation of inability to entrust the
                subject matter of this agreement or if the Contractor blatantly
                opposes the provisions of this agreement, by which the parties
                mean, in particular:
                <ol type="a">
                  <li>
                    the Contractor's behavior consisting of failure to perform
                    the obligations outlined in § 1, despite the Principal's
                    prior request to cease violations,
                  </li>
                  <li>
                    violation by the Contractor of the prohibition of
                    competition,
                  </li>
                  <li>
                    disclosure of Confidential Information by the Contractor,
                  </li>
                  <li>any other violations of this Agreement.</li>
                </ol>
              </li>
              <li>
                In the event of termination of the contract, the Contractor
                agrees to return the materials provided for the duration of the
                contract by the Principal within 14 days from the date of
                termination or expiration of the contract. If the Contractor
                fails to return the materials within the specified period, the
                Principal may impose a financial penalty on the Contractor with
                the value of the materials received. In addition, the Contractor
                may be charged shipping costs.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px; margin-top: 10px">
              <strong>§ 6 Remuneration</strong>
            </p>
            <ol>
              <li>
                For the proper performance of the activities listed in § 1, the
                Contractor will be paid according to the following schedule.
                <br />
                Remuneration will depend on the number of active learners (those
                who have a binding contract for educational services with the
                Principal in a given settlement period) in a group and will be
                settled according to the following table:
                <br />
                <div>
                  <span>Table 1: rates for lessons in fixed courses</span>
                  <table
                    style="
                      border: 1px solid;
                      text-align: left;
                      font-size: 12px;
                      width: 100%;
                    "
                  >
                    <tbody>
                      <tr>
                        <td style="border: 1px solid; padding: 10px">
                          <b
                            >The gross rate for 1 lesson of a 60-minute
                            course</b
                          >
                        </td>
                        <td style="border: 1px solid; padding: 10px">
                          <b
                            >Number of active learners in the group in the
                            billing month</b
                          >
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid; padding: 10px">{{ stawka1 }} {{ stawka1 ? 'zł' : null }}</td>
                        <td style="border: 1px solid; padding: 10px">1</td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid; padding: 10px">{{ stawka2 }} {{ stawka2 ? 'zł' : null }}</td>
                        <td style="border: 1px solid; padding: 10px">2-5</td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid; padding: 10px">{{ stawka3 }} {{ stawka3 ? 'zł' : null }}</td>
                        <td style="border: 1px solid; padding: 10px">
                          6 and more
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <br />
                <br />

                <div>
                  <span>Table 2: rates for demonstration lessons</span>
                  <table
                    style="
                      border: 1px solid;
                      text-align: left;
                      font-size: 12px;
                      width: 100%;
                    "
                  >
                    <tbody>
                      <tr>
                        <td style="border: 1px solid; padding: 10px">
                          <b>The gross rate for 1 demonstration lesson</b>
                        </td>
                        <td style="border: 1px solid; padding: 10px">
                          <b>Lesson mode</b>
                        </td>
                        <td style="border: 1px solid; padding: 10px">
                          <b>Length of lesson</b>
                        </td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid; padding: 10px">30 PLN</td>
                        <td style="border: 1px solid; padding: 10px">online</td>
                        <td style="border: 1px solid; padding: 10px">30 min</td>
                      </tr>
                      <tr>
                        <td style="border: 1px solid; padding: 10px">60 PLN</td>
                        <td style="border: 1px solid; padding: 10px">
                          stationary
                        </td>
                        <td style="border: 1px solid; padding: 10px">60 min</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </li>
              <br />
              <li>
                The total monthly remuneration will be derived from the hourly
                rate resulting from paragraphs 1 and 2 of this paragraph and the
                number of lessons conducted in a given month, based on the
                statement and documentation referred to in paragraph 4 of this
                paragraph. If one lesson, according to the schedule, lasts more
                or less than 60 minutes then the rate of remuneration for one
                lesson will be proportionally reduced or increased. The
                Contractor shall not be entitled to additional compensation for
                performing additional activities related to the preparation,
                organization, and reporting of lessons.
              </li>
              <li>
                The Contractor shall be entitled to an additional PLN 10.00 (in
                words: ten zlotys) gross added to the hourly rate (determined
                according to the table in paragraph 1 § 6) if the place of the
                lesson is at least 25 km away from the nearest stationary unit
                of Profi Lingua School or from the Contractor's place of
                residence (only if the distance to the school is greater than
                the distance to the Contractor's place of residence).
              </li>
              <li>
                The Contractor shall prepare and submit to the Principal in
                electronic form:
                <ol type="a">
                  <li>
                    statement of the number of hours worked in a given month,
                    generated from the hours recording tools provided by the
                    Principal, no later than the first working day of the
                    following month.
                  </li>
                  <li>
                    maintained documentation confirming the implementation of
                    classes in a given month, in particular, class logs and
                    attendance lists of students, no later than the last day of
                    the month for which the Contractor is entitled to
                    remuneration for the execution of the order.
                  </li>
                </ol>
                The statement and documentation verified by the Principal shall
                be the basis for payment of remuneration to the Contractor.
              </li>
              <li>
                Principal may reduce by an amount of up to 15% the amount of
                gross remuneration for a given month, in case of non-compliance
                with the provisions of the contract in particular: failure to
                meet the stated availability, lateness to classes, failure to
                write to e-mails and to answer phone calls from persons
                designated as contact persons by the Principal, legitimate
                complaints from parents about the quality of the lessons,
                failure to meet the obligation to evaluate children in reports,
                failure to observe the rules of personal culture in classes and
                in contact with persons designated by the Principal, failure to
                comply with the guidelines for the program and quality of the
                educational classes provided by the Principal.
              </li>
              <li>
                The Contractor's remuneration shall be paid in arrears every
                month by the 15th of each month, by wire transfer to the bank
                account number designated by the Contractor.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px; margin-top: 25px">
              <strong>§ 7 Bonus</strong>
            </p>
            <ol>
              <li>
                The Principal may award the Contractor a discretionary bonus of
                up to 15% of gross salary, the award of which shall depend on
                the degree of completion of assigned individual tasks and global
                performance.
              </li>
              <li>
                In addition, the Principal may award an additional discretionary
                bonus for other purposes unrelated to paragraph 1 of this
                section.
              </li>
              <li>
                The bonus shall not be like a claim, and its award, as well as
                the determination of its amount, shall be at the discretion of
                the Principal.
              </li>
              <li>
                The calculation and payment of the bonus shall be made within 15
                days after the end of the monthly accounting period.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px; margin-top: 10px">
              <strong>§ 8 Confidential information</strong>
            </p>
            <ol>
              <li>
                By Confidential Information, the parties mean all information
                provided to the Contractor by the Principal or otherwise
                obtained by the Contractor in connection with the performance of
                this Agreement, including technical, technological,
                organizational, or other information of economic value that
                relates to the Principal and its business, and, in particular,
                the teaching materials used by the Principal, the contact
                database of the Principal's customers (including customers who
                have terminated their cooperation with the Principal up to 12
                months after the end of the contract), computer systems and
                other information obtained from the Principal during the
                performance of the contract.
              </li>
              <li>
                The Contractor agrees that Confidential Information obtained
                under this agreement shall be kept confidential by the
                Contractor and used exclusively for the performance of this
                contract. The Confidential Information shall not be used for any
                other purpose or disclosed or made available to any third party,
                in whole or in part. The obligation of confidentiality applies
                to Confidential Information obtained by the Contractor from the
                Principal in writing and disclosed to the Contractor orally,
                visually, electronically, or otherwise. The Contractor agrees to
                keep the Confidential Information received in confidence and not
                to disclose it to anyone without the written consent of the
                Principal.
              </li>
              <li>
                The Contractor, upon the termination of the cooperation of the
                Parties, or, before its termination - at any request of the
                Principal - shall be obligated to return to the Principal within
                3 days all Confidential Information, together with documentation
                and other media on which it was recorded, as well as, copies of
                documentation or media containing such Information. The
                Contractor undertakes to delete from the memory of computers and
                other devices all received or made materials in such a way that
                they cannot be reproduced or used in any form in the future.
              </li>
              <li>
                If the Contractor violates the provisions of the preceding
                paragraphs, in particular, by disclosing or providing access to
                materials and Confidential Information in violation of this
                agreement, the Contractor shall be obligated to pay to the
                Principal a contractual penalty in the amount of PLN 5,000.00
                (in words: five thousand zlotys) for each such violation. Such
                penalty shall be payable within 14 days from the date of the
                Principal's submission of a statement charging the Contractor
                with the contractual penalty.
              </li>
              <li>
                If the amount of damage or lost benefits of the Principal
                resulting from violation by the Contractor's breach of the
                provisions of this agreement will exceed the amount of the
                contractual penalty indicated in paragraph 4 of this section,
                the Principal may claim supplementary damages under the general
                rules under the Civil Code.
              </li>
              <li>
                The Principal shall also consider any use of the Contractor's
                teaching materials for the Contractor's private purposes and for
                teaching purposes of persons who are not the Principal's clients
                as a violation of the principles described in this agreement.
              </li>
              <li>
                Notwithstanding the expiration or termination of this Agreement,
                the Contractor's obligations to maintain the confidentiality of
                Confidential Information shall remain in effect indefinitely.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px; margin-top: 30px">
              <strong>§ 9 Prohibition of competition</strong>
            </p>
            <ol>
              <li>
                The following shall be considered by the Parties as competitive
                activities within the meaning of this paragraph: offering or
                providing any educational services by the Contractor in any form
                to the Principal's customers who have entered into a contract
                with the Principal no later than the date of expiration of this
                Agreement.
              </li>
              <li>
                Competitive activities shall also be deemed to include:
                <ol type="a">
                  <li>
                    provision by the Contractor of work for an entity engaged in
                    competitive activities with the Principal;
                  </li>
                  <li>
                    provision of services by the Contractor under any civil law
                    contract for the benefit of an entity engaged in competitive
                    activity concerning the Principal,
                  </li>
                  <li>
                    operation by the Contractor of an enterprise conducting
                    business competitive to the Principal, including through a
                    third party,
                  </li>
                  <li>
                    being a partner in a company conducting business
                    competitively to the Principal, sitting by the Contractor in
                    the bodies of entities conducting business competitively to
                    the Principal, e. acting as an agent, attorney, or proxy of
                    persons conducting business competitive to the Principal.
                  </li>
                </ol>
              </li>
              <li>
                The Contractor agrees not to engage in any activity that is
                competitive with the Principal's business as defined in
                paragraph 1 of this section during the term of the cooperation
                described in this agreement.
              </li>
              <li>
                If it is the Client, who is a current client of the Principal,
                who himself proposes cooperation to the Contractor, the
                Contractor is obliged to inform the Client of the aforementioned
                prohibition of competitive activity and refusal to cooperate,
                and is obliged to inform the Principal of the situation.
              </li>
              <li>
                The Principal reserves the right to check with the Contractor
                whether the provisions of this paragraph are duly implemented by
                the Contractor.
              </li>
              <li>
                The Principal may charge the Contractor a penalty in the amount
                of PLN 20,000.00 (in words: twenty thousand zlotys) for each
                violation of the non-compete provisions of this agreement. In
                such a case, the Principal may also claim damages exceeding the
                value of the reserved contractual penalty.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px; margin-top: 30px">
              <strong
                >§ 10 Delivery and correspondence, consent to use of image,
                GDPR</strong
              >
            </p>
            <ol>
              <li>
                The parties agree that unless written notice of a change of
                mailing address is given, all correspondence addressed to the
                addresses given in the designation of the parties shall be
                deemed to have been delivered no later than the date of the
                second advice letter.
              </li>
              <li>
                E-mail addresses are provided in the designation of the parties.
                A letter sent by e-mail shall be considered delivered as soon as
                the other party has had an opportunity to read it.
              </li>
              <li>
                The Contractor agrees to the use of his image, as specified in
                the Annex to this Agreement.
              </li>
              <li>
                The Contractor shall comply with the provisions of the
                Regulation of the European Parliament and of the Council (EU)
                2016/679 of April 27, 2016, on the protection of natural persons
                concerning the processing of personal data and the free flow of
                such data and repealing Directive 95/46/EC (GDPR) and the Act of
                May 10, 2018, on the protection of personal data (i.e. Journal
                of Laws of 2019, item 1781, as amended). The Contractor agrees
                to the processing of his personal data, following the
                information clause attached to this contract.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px; margin-top: 15px">
              <strong>§ 11 Disputes and competent court</strong>
            </p>
            <p>
              The parties declare that they will use their best efforts to
              resolve disputes arising from this agreement amicably. In case of
              disputes that cannot be resolved amicably within 14 days from the
              date of receipt by the other party of a written request for a such
              amicable resolution, they shall be submitted to the court of
              competent jurisdiction for the Principal's seat.
            </p>
            <br />

            <p align="center" style="margin-bottom: 0px">
              <strong>§ 12 Completeness and amendment of the Agreement</strong>
            </p>
            <ol>
              <li>
                This Agreement shall terminate and supersede all other previous
                written or oral understandings, agreements, arrangements, and
                contracts of the Parties to the extent covered herein, which are
                hereby terminated.
              </li>
              <li>
                The Parties declare that, apart from this Agreement, there are
                no additional arrangements or agreements between them regarding
                the subject matter of this Agreement.
              </li>
              <li>
                Any amendments to this Agreement shall be in writing under pain
                of nullity.
              </li>
              <li>
                Termination of this agreement shall be in writing under pain of
                nullity.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px">
              <strong>§ 13 Severability clause</strong>
            </p>
            <p>
              If any provision of this Agreement proves to be invalid in whole
              or in part, the remaining provisions shall remain in force, and
              the Parties undertake, at the request of either of them, to
              replace the invalid provisions with provisions whose legal force
              and economic effect are most similar to the provisions being
              replaced.
            </p>
            <br />

            <p align="center" style="margin-bottom: 0px">
              <strong>§ 14 Applicable Law</strong>
            </p>
            <ol>
              <li>This Agreement shall be governed by Polish law.</li>
              <li>
                In matters not regulated by this Agreement, the relevant
                provisions of law, in particular the provisions of the Civil
                Code, shall apply.
              </li>
            </ol>
            <br />

            <p align="center" style="margin-bottom: 0px">
              <strong>§ 15 Number of copies of the contract</strong>
            </p>
            <p>
              This agreement is drawn up in two counterparts, one for each
              party.
              <br />
            </p>
            <br />

            <div class="cointainer">
              <div class="right-cointainer">
                {{ imieNazwisko }}<br />
                <span style="margin-left: 0%"
                  ><b>Podpis Zleceniobiorcy/ Contractor's signature</b></span
                >
              </div>
            </div>
            <br />

            <div
              style="page-break-before: always; position: relative; top: -3px"
            >
              <p><strong>Attachment No. 1 CONSENT TO USE OF IMAGE</strong></p>
              <p>
                I hereby declare that I grant Tutore Poland Sp. z o.o., with its
                registered seat in Lodz, 157A Piotrkowska St., 90-440, KRS
                0000670834, NIP: 727-28-12-193, REGON: 366891567, (hereinafter:
                Tutore Poland Sp. z o.o.) permission, free of charge, to record,
                and unlimited in time and territory multiple uses and
                dissemination of my image in the form of a photograph in
                connection with the execution of the contract of mandate to
                place it in the company's e-mail footer. The image will be used
                only for the duration of the contract in the form of a
                photograph in an email correspondence sent on behalf of the
                Principal.
              </p>
              <p>
                As well as I hereby declare that I give Tutore Poland Sp. z o.o.
                permission, free of charge, to record and unlimited in time and
                territory multiple uses and distribution of my voice or
                statements recorded during the performance of this contract for
                the provision of services using telephones with VoIP connection
                (Voice over Internet Protocol).
              </p>
              <p>
                This consent covers the following fields of exploitation: use,
                recording, processing, and duplication of images/recordings
                made, trading in copies on which the image or voice was recorded
                and reproducing the image/voice with all available techniques
                and methods, distribution and publication, in materials serving
                the activities of Tutore Poland in particular in training,
                educational and promotional materials in any form.
              </p>
              <p>
                Tutore Poland Sp. z o.o. has the exclusive right to decide on
                the form and time of use of my image, voice, and speech in whole
                or in the form of any fragments. The image may be used for
                various forms of electronic image processing, framing, and
                composition, without obligation to accept the final product, but
                not in forms that are offensive or generally considered
                unethical.
              </p>
            </div>

            <div
              style="page-break-before: always; position: relative; top: -3px"
            >
              <p><strong>Attachment No. 2 INFORMATION CLAUSE</strong></p>
              <p>Information clauses from Article 13 of GDPR</p>
              <p>
                Under Article 13 (1) and (2) of Regulation (EU) 2016/679 of the
                European Parliament and of the Council of 27 April 2016 on the
                protection of natural persons about the processing of personal
                data and the free movement of such data and repealing Directive
                95/46/EC (General Data Protection Regulation) (Official Journal
                of the EU L 119 of 04.05.2016, p. 1), hereinafter referred to as
                "GDPR", I inform you that:
              </p>
              <p style="margin-bottom: 10px">
                The administrator of your personal data is Tutore Poland Sp. z
                o.o., headquartered in Lodz at Piotrkowska 157A, 90-440, KRS
                0000670834, hereinafter referred to as „PDA”.
              </p>
              <p style="margin-bottom: 10px">
                You may contact ADO by writing to Tutore Poland Sp. z o.o, 157A
                Piotrkowska St., 90-440, e-mail kadry@tutore.eu and by
                contacting the Data Protection Officer at the e-mail address:
                mlokaj@mlkancelaria.com
              </p>
              <p>ADO processes personal data to:</p>
              <ol type="a">
                <li>establishing cooperation - Art. 6 (1) letter b, f GDPR,</li>
                <li>
                  ensuring contact between the Parties (email address, telephone
                  number) - Art. 6(1)(b, f) RODO, c. realization of rights and
                  obligations arising from the contract for the vision of
                  services - Art. 6(1)(b, c, f) RODO, d. keeping a record of
                  correspondence - Art. 6(1)(c, f) GDPR,
                </li>
                <li>
                  record of the course of cooperation (including the execution
                  of payments) - Art. 6(1)(b, c) RODO, f. assertion of claims
                  and rights - Art. 6(1)(b, f) GDPR,
                </li>
                <li>
                  fulfillment of tax obligations - Art. 6 (1) lit. b, c GDPR,
                </li>
              </ol>
              <br />
              <p style="margin-bottom: 10px">
                Recipients of personal data are entities entrusted by ADO with
                the processing of personal data, in particular: providers of
                technical and organizational services, providers of accounting,
                human resources, legal and consulting services, banks (payment
                processing), public authorities in the performance of duties
                related to the conduct of PDA's business.
              </p>
              <p style="margin-bottom: 10px">
                PDA does not transfer personal data outside the European
                Economic Area.
              </p>
              <p style="margin-bottom: 10px">
                Personal data will be kept for the period of execution of the
                agreement, and then for the period determined by generally
                applicable laws, including, in particular: the assertion of
                claims (the period of limitation of claims), maintenance of
                accounting books and tax records (5 years from the end of the
                calendar year in which the tax obligation arose).
              </p>
              <p style="margin-bottom: 10px">
                The person whose data is processed has the right to access
                his/her data and receive a copy of them, the right to rectify
                (amend) his/her data, the right to delete data, the right to
                withdraw consent, the right to limit processing, the right to be
                forgotten, the right to object, the right to data portability,
                the right to complain with the Office for Personal Data
                Protection.
              </p>
              <p style="margin-bottom: 10px">
                Your provision of personal data and consent to their processing
                and dissemination of your image is voluntary, but it is a
                prerequisite for the establishment of cooperation and the
                possible conclusion of a written agreement and the exercise of
                rights and obligations by PDA.
              </p>
              <p style="margin-bottom: 10px">
                There is no automated decision-making, including profiling,
                using the collected personal data as part of PDA's activities.
              </p>
              <p style="margin-bottom: 10px">
                Scope of data subject to processing: name, email address, phone
                number, image, PESEL.
              </p>
              <div style="float: right; margin-top: 20px">
                <p style="margin-bottom: 10px">{{ imieNazwisko }}</p>
                <p style="margin-bottom: 10px"><b>Contractor's signature</b></p>
              </div>
            </div>

            <div style="page-break-before: always">
              <p style="margin-bottom: 10px">
                <strong>
                  Attachment No. 3 Supplementary authorization for the
                  processing of personal data in the collection of paper and
                  electronic
                </strong>
              </p>
              <p class="p-margin">
                Under Article 29 of Regulation (EU) 2016/679 of the European
                Parliament and of the Council of April 27, 2016, on the
                protection of natural persons about the processing of personal
                data and the free flow of such data and repealing Directive
                95/46/EC (General Data Protection Regulation), hereinafter GDPR,
                hereby:
              </p>
              <p class="p-margin">
                as of the date of signing of the authorization by both parties
              </p>
              <p class="p-margin">
                I authorize Mr./Ms {{ imieNazwisko }} Contractor of the Tutore
                Poland Sp. z o.o. executing a contract of the mandate by
                teaching in the department of education to
              </p>
              <p class="p-margin">
                process personal data contained in the following sets of
                personal data:
              </p>
              <ol type="a">
                <li>
                  electronically:
                  <ul>
                    <li>
                      collection of personal data of Customers: parents (legal
                      guardians) of children, adolescents, and adults using
                      services offered by Tutore Poland- name and surname,
                      address of residence, contact phone, e-mail address,
                    </li>
                    <li>
                      a collection of personal data of Customers: children,
                      adolescents, and adults using the services offered by
                      Tutore Poland- name and surname, address of residence,
                      contact phone, and e-mail address.
                    </li>
                  </ul>
                </li>
                To the extent of inspection, introduction, modification,
                deletion, and archiving of personal data covered by the
                aforementioned collections.
              </ol>
              <p class="p-margin">
                This authorization does not authorize the granting of further
                authorizations and expires on the date of termination of the
                assignment contract, and may be modified or revoked at any time.
                I obligate you to process the personal data contained in the
                aforementioned sets of personal data to the extent and in the
                manner required to fulfill your official duties to the Principal
                - Personal Data Controller. I oblige you to process personal
                data by the authorization granted, the Regulation of the
                European Parliament and the Council (EU)2016/679 of April 27,
                2016, on the protection of natural persons through the
                processing of personal data and the free movement of such data
                and repealing Directive 95/46/EC ( Official Journal of the EU L
                119, p.1) and the provisions of the Act of May 10, 2018, on the
                protection of personal data (Journal of Laws of 2018, item 1000)
                and applicable at Tutore Poland Sp. z o.o..internal regulations
                on the protection of personal data. Violation of the
                aforementioned obligations may result in criminal liability and
                is grounds for termination of the contract of assignment.
              </p>

              <div class="container" style="page-break-before: always">
                <table
                  style="
                    border: 1px solid;
                    text-align: left;
                    font-size: 12px;
                    width: 100%;
                  "
                >
                  <tr>
                    <td id="oswiadczenie">
                      <p align="center" class="subheading">
                        <strong>CONTRACTOR'S STATEMENT</strong>
                      </p>
                      <ol>
                        <li>
                          I, the undersigned, declare that:
                          <ol type="a">
                            <li>
                              I have read and I acknowledge the content and
                              scope of the authorisation,
                            </li>
                            <li>
                              the content of the authorisation is clear and
                              comprehensible to me and any doubts have been
                              comprehensively explained to me by the authorised
                              person,
                            </li>
                            <li>
                              I undertake to process the personal data contained
                              in the aforementioned personal data files to the
                              extent and in the manner required to fulfil my
                              duties towards the Principal,
                            </li>
                            <li>
                              I undertake to process the personal data in
                              accordance with the authorisation granted, the
                              GDPR regulations and the internal procedures in
                              force at the Employer, including the Privacy
                              Policy,
                            </li>
                            <li>
                              I undertake to keep in secret the personal data to
                              which I have or will have access in relation to
                              the performance of duties for the benefit of
                              Tutore Poland Sp. z o.o., and to keep in secret
                              the ways of securing personal data, also after
                              revoking or changing the authorization, and also
                              after the termination of the contract of mandate.
                            </li>
                          </ol>
                        </li>
                      </ol>
                      <div
                        class="right-cointainer"
                        style="float: right; margin-top: 20px"
                      >
                        <span style="font-size: 14px">{{ imieNazwisko }}</span>
                        <br />
                        <span>legible signature of the Contractor</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>

              <p class="subheading p-margin" style="text-align: center">
                {{ zamawiajacy }}
                <br />
                on behalf of the Administrator
              </p>
              <br />
              <p align="center">
                This authorization was revoked on the date of termination of the
                contract of assignment.
              </p>
            </div>

            <div style="page-break-before: always">
              <p>
                <b
                  >Attachment No. 4 Information about monitoring of classes
                  online and recording of internal training on - line</b
                >
              </p>
              <br />
              We would like to inform you that Tutore Poland Sp. z o.o. uses
              technical means for monitoring on - line classes and recording
              internal online training. Monitoring includes devices recording
              images and sounds, which are used by the user to realize online
              classes i.e. Clickmeeting platform or Zoom application, and in
              case of internal training online Zoom application. Tutore Poland
              Sp. z o.o. uses monitoring for the following purposes: to ensure
              the highest standards of service of lessons realized by
              employees/contractors, the correctness of performance of entrusted
              activities and possible improvement of the quality of lessons, to
              protect the interests of the company in situations of disputes
              with the customer (evidence), and in the case of internal training
              on - line to ensure the possibility of making the recordings
              available to new employees/contractors. We inform you that: the
              audio-visual and audio monitoring system of online classes
              consists of a recording system of Clickmeeting or Zoom platform
              and server on which online classes are recorded, access to the
              recording of online classes has persons authorized by the
              Management Board of Tutore Poland Sp. z o.o. i.e. Manager of the
              Call Center Department, Director of Process Management, Teamleader
              of the Call Center Department, persons who have access to the
              recorded image are aware of the responsibility for personal data
              protection and have appropriate authorization issued by the
              Administrator of personal data. In the course of the recording,
              processing of personal data in the form of voice, image, and name
              of the employee/contractor conducting the class or training takes
              place. The Administrator of personal data obtained in the course
              of monitoring online classes and in the course of recording
              internal online training is Tutore Poland Sp. z o.o., which in
              connection with the above-described activity includes below the
              required information clause concerning the processing of personal
              data.
            </div>

            <div style="margin-top: 40px; font-size: 10px">
              <p>
                <b>Attachment No. 5 INFORMATION ON PERSONAL DATA PROCESSING</b>
              </p>
              <ol>
                <li>
                  I would like to inform you that the Administrator of your
                  personal data as a Contractor is Tutore Poland Sp. z o.o. with
                  its registered office at Piotrkowska 157A,
                  90-440 Łódź, KRS: 0000670834, NIP: 7272812193, tel. 500 965
                  135, info@tutore.eu
                </li>
                <li>
                  By providing you with this information on the processing of
                  personal data, the Administrator is complying with the legal
                  obligation under Article 15 (1) of Regulation (EU) 2016/679 of
                  the European Parliament and of the Council of April 27, 2016,
                  on the protection of natural persons about the processing of
                  personal data and the free movement of such data and repealing
                  Directive 95/46/EC (General Data Protection Regulation),
                  hereinafter referred to as GDPR.
                </li>
                <li>
                  The Administrator obtains information about you in connection
                  with a statutory obligation, which is necessary for the
                  effective implementation of the cooperation process. About
                  personal data not affected by the statutory condition of
                  necessity - their provision is voluntary
                </li>
                <li>
                  Your personal data shall be processed for the following
                  purposes, on the following basis and for the following period:
                  <ol type="a">
                    <li>
                      conclusion and execution of a civil law contract - to
                      fulfill the obligation under the Civil Code (Article
                      6(1)(b), (c), (f) GDPR) - for the period of cooperation,
                    </li>
                    <li>
                      calculation and payment of remuneration - to fulfill the
                      obligation under the Civil Code (Article 6(1)(c), Article
                      9(2)(b) GDPR) - for the period of cooperation,
                    </li>
                    <li>
                      payroll deductions – to fulfill payroll enforcement
                      obligations under the Civil Procedure Code, the Law on
                      Administrative Enforcement Proceedings, the Law on
                      Bailiffs (Article 6(1)(c) of the GDPR) - for the period
                      designated by generally applicable laws,
                    </li>
                    <li>
                      fulfillment of tax obligations - to fulfill the
                      obligations of an income taxpayer under the Tax Ordinance,
                      the Personal Income Tax Act, and other tax regulations
                      (Article 6(1)(c) of the GDPR) - for a period of 5 years
                      from the end of the calendar year,
                    </li>
                    <li>
                      fulfillment of obligations to the Social Insurance
                      Institution – to fulfill obligations of a payer of social
                      and health insurance contributions arising from the Act on
                      pensions from the Social Insurance Fund, the Act on the
                      social insurance system, and the Act on health care
                      benefits financed from public funds (Article 6(1)(c),
                      Article 9(2)(b) GDPR) - for a period of 5 years from the
                      end of the calendar year,
                    </li>
                    <li>
                      performance of accounting obligations - to fulfill
                      obligations under the Accounting Act, the Tax Ordinance,
                      and the Corporate Income Tax Act (Article 6(1)(c) GDPR) -
                      for a period of 5 years from the end of the accounting
                      year in which the event occurred,
                    </li>
                    <li>
                      physical security of the Administrator's buildings,
                      premises, and property – based on the Administrator's
                      legitimate interest (Article 6(1)(f) GDPR) - for the
                      period of cooperation,
                    </li>
                    <li>
                      to ensure the highest standards of service of lessons
                      provided by the Collaborators via the ClickMeeting or Zoom
                      platform, the correctness of the performance of the
                      entrusted activities, and possible improvement of the
                      quality of the lessons, safeguarding the interests of the
                      company in situations of disputes with the client
                      (evidence) through monitoring and recording of online
                      courses - based on the voluntary consent of the recorded
                      person (Article 6(1)(a) GDPR) - the Image and voice of the
                      Collaborator will be processed for a period of 3 months.
                      If the recordings of the recorded classes constitute
                      evidence in a proceeding conducted under the provisions of
                      the law, or the Administrator becomes aware that they may
                      constitute evidence in the proceeding, this period is
                      extended until the legal conclusion of the proceeding.
                      After the expiration of these periods, recordings
                      containing personal data shall be destroyed,
                    </li>
                    <li>
                      to ensure that recordings can be made available to new
                      Employees and Associates recording online training
                      conducted via the Zoom platform - based on the voluntary
                      consent of the person being recorded (Article 6(1)(a) of
                      the GDPR) - the Image and voice of the Associate will be
                      processed until the consent is withdrawn. If the consent
                      is withdrawn, the recordings containing personal data
                      shall be destroyed,
                    </li>
                    <li>
                      to ensure the highest standards of customer service
                      quality, for training purposes - allowing to improve the
                      quality of service, to secure the interests of the company
                      in situations of disputes with customers (evidence), to
                      ensure the safety of Co-workers in case of undesirable and
                      dangerous events on the part of Customers (e.g. criminal
                      threats) by monitoring telephone conversations with the
                      Administrator's Customers – based on the Administrator's
                      legitimate interest (Article 6(1)(f) GDPR) - for a period
                      of up to 3 months. If the recordings of the recorded
                      telephone conversations constitute evidence in a
                      proceeding conducted based on the law, or the
                      Administrator becomes aware that they may constitute
                      evidence in the proceeding, this period is extended until
                      the proceeding is legally concluded. After the expiration
                      of these periods, recordings containing personal data
                      shall be destroyed,
                    </li>
                    <li>
                      creation of photo reports from camps for children and
                      teenagers on a flash drive for Customers, a Facebook fan
                      page, and the Website www.musicandmore.pl - based on the
                      voluntary consent of the recorded person (Article 6(1)(a)
                      of RODO) - The image and voice of the Associate will be
                      processed until the consent is withdrawn. If the consent
                      is withdrawn, the recordings containing personal data
                      shall be destroyed,
                    </li>
                    <li>
                      pursuing claims or defending against claims – based on the
                      Administrator's legitimate interest (Article 6(1)(f) of
                      the GDPR) consisting in appearing in court cases - in the
                      case of pending proceedings for the duration of the
                      proceedings until their final and legally binding
                      conclusion, and for the period specified by generally
                      applicable laws.
                    </li>
                  </ol>
                </li>
                <li>
                  The recipients of your personal data will be:
                  <ul>
                    <li>
                      public administration bodies (e.g., Social Insurance
                      Institutions, Tax Offices) - by relevant legal
                      regulations;
                    </li>
                    <li>
                      health care institutions for occupational medicine
                      purposes;
                    </li>
                    <li>
                      external entities providing and supporting the Principal's
                      ICT systems (both general ICT infrastructure, e-mail, as
                      well as IT systems used by the Principal for personnel and
                      financial services or circulation of documents related to
                      employment) - by relevant agreements of entrustment of
                      personal data processing and ensuring the application by
                      the above entities of adequate technical and
                      organizational measures to ensure data protection,
                    </li>
                    <li>accounting offices:</li>
                    <li>
                      banks - to pay salaries and other monetary benefits to the
                      Principal in case they are paid with the consent of the
                      Contractor to a bank account
                    </li>
                    <li>
                      contractors - to enable contractors (potential and
                      current) to contact them or for the ongoing implementation
                      of concluded agreements, and related to the Contractor's
                      position;
                    </li>
                    <li>
                      Principal's associates who provide services to Tutore
                      Poland Sp. z o.o., to enable the associates to contact the
                      Contractor, entities providing additional services to
                      Contractors, only if the Contractor uses these services.
                    </li>
                    <li>insurance institutions</li>
                    <li>
                      foreign administration organizations in the EU countries
                      where the contract is executed (applies to the execution
                      of the contract abroad) entities that train and perform
                      health and safety duties (if there is no health and safety
                      unit at the Principal's premises)
                    </li>
                  </ul>
                </li>
                <li>
                  You have the right to:
                  <ol type="a">
                    <li>
                      <strong>Access to data</strong> — to obtain confirmation
                      from the Administrator as to whether your personal data
                      are being processed. If data is being processed, you are
                      entitled to access the data (Article 15 GDPR);
                    </li>
                    <li>
                      <strong>obtain a copy of the data</strong> — to obtain a
                      copy of the data being processed, the first copy is free
                      of charge and for subsequent copies, the relevant
                      Controller may charge a reasonable fee based on
                      administrative costs (Article 15(3) GDPR);
                    </li>
                    <li>
                      <strong>rectification</strong> — request the rectification
                      of personal data that is inaccurate or the completion of
                      incomplete data (Article 16 GDPR);
                    </li>
                    <li>
                      <strong>erasure</strong> — request the erasure of personal
                      data where the Controller no longer has a legal basis for
                      the processing or the data are no longer necessary for the
                      purposes of the processing (Article 17 GDPR);
                    </li>
                    <li>
                      <strong>restriction of processing</strong> — request the
                      restriction of the processing of personal data (Art. 18
                      GDPR) when:
                      <ol type="i">
                        <li>
                          you contest the accuracy of the personal data - for a
                          period allowing the Administrator to verify the
                          accuracy of the data,
                        </li>
                        <li>
                          the processing is unlawful, and you object to the
                          erasure of the data by requesting the restriction of
                          its use,
                        </li>
                        <li>
                          The Administrator no longer needs the data, but it is
                          for you to establish, assert or defend your claims;
                        </li>
                        <li>
                          you have lodged an objection to the processing - until
                          it is determined whether the legitimate grounds on the
                          part of the Administrator override the grounds for
                          your objection;
                        </li>
                      </ol>
                    </li>
                    <li>
                      <strong>data portability</strong> — to receive in a
                      structured, commonly used machine-readable format the
                      personal data concerning you provided to the Controller,
                      and to request that this data be sent to another
                      Controller where the data is processed on the basis of
                      your consent, or a contract concluded with you, and where
                      the data is processed by automated means (Article 20
                      GDPR);
                    </li>
                    <li>
                      <strong>objection</strong> — to object to the processing
                      of personal data for the legitimate purposes of the
                      Controller, on grounds related to your particular
                      situation, including profiling. The Controller shall
                      assess the existence of valid legitimate grounds for the
                      processing, overriding your interests, rights and freedoms
                      or grounds for establishing, pursuing or defending claims.
                      If according to the assessment, your interests outweigh
                      the interests of the Controller, the Controller will be
                      obliged to stop processing the data for these purposes
                      (Article 21 GDPR);
                    </li>
                    <li>
                      <strong
                        >the right to lodge a complaint with the supervisory
                        authority</strong
                      >
                      – the President of the Office for the Protection of
                      Personal Data, if you consider that the processing of
                      personal data concerning you is in breach of the law.
                      Complaints can be submitted in the form of:
                      <ul>
                        <li>
                          in writing to the address: 2 Stawki Street, 00-193
                          Warsaw,
                        </li>
                        <li>electronically via the ePUAP platform.</li>
                      </ul>
                    </li>
                  </ol>
                </li>
                <li>
                  In the course of personal data processing, there is no
                  exclusively automated decision-making or profiling referred to
                  in Article 22 (1) and (4) of the GDPR, which means that no
                  decisions concerning you will be made automatically and no
                  profiles of you will be created.
                </li>
                <li>
                  You are obliged to inform the Principal of any changes
                  concerning your personal data provided to the Principal by the
                  Agreement.
                </li>
              </ol>
            </div>

            <div style="page-break-before: always">
              <div class="container">
                <table
                  style="
                    border: 1px solid;
                    text-align: left;
                    font-size: 12px;
                    width: 100%;
                  "
                >
                  <tr>
                    <td id="oswiadczenie">
                      <p align="center" class="subheading">
                        <strong>CONTRACTOR'S STATEMENT</strong>
                      </p>
                      <ol>
                        <li>
                          I, the undersigned, declare that:
                          <ol type="a">
                            <li>
                              I have read the Information on monitoring classes
                              on - line and recording internal training online
                              and the Information Clause and acknowledge it,
                            </li>
                            <li>
                              the content of the Information and Clause is
                              understandable and clear to me, and any doubts
                              have been explained to me by an authorized person
                              in a comprehensive manner.
                            </li>
                          </ol>
                        </li>
                        <li>
                          On a completely voluntary basis, I consent to the
                          processing of my personal data for the purposes
                          indicated in the Information on monitoring of classes
                          online and recording of internal training online.
                        </li>
                        <li>
                          I have been informed that my personal data are
                          processed based on my voluntary consent and that I
                          have the right to withdraw it at any time, whereby the
                          withdrawal of consent shall have legal effect from the
                          moment of its submission and shall not affect the
                          processing of my personal data for purposes related to
                          the implementation of the study before the submission
                          of the statement of withdrawal of consent.
                        </li>
                        <li>
                          By Article 81 paragraph.1 of the Act on Copyright and
                          Related Rights I consent to the dissemination of my
                          image by Tutore Poland Sp. z o.o. for the purposes
                          indicated in the Information on monitoring online
                          activities and recording internal training online.
                        </li>
                      </ol>
                      <div style="float: right; margin-top: 20px">
                        <span style="font-size: 14px">{{ imieNazwisko }}</span>
                        <br />
                        <span
                          >legible signature of the Employee/Contractor</span
                        >
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div style="margin-top: 5px; page-break-before: always">
      <p><em>Załącznik nr 6 / Annex 6</em></p>
      <p align="center" class="subheading">
        <strong>Oświadczenie Zleceniobiorcy / Contractor's Statement</strong>
      </p>

      <table
        style="
          border: 1px solid;
          text-align: left;
          font-size: 12px;
          width: 100%;
        "
      >
        <tbody>
          <tr>
            <td
              style="
                border: 1px solid;
                background-color: #a4c2f4;
                text-align: center;
                width: 300px;
              "
            >
              <p class="cell-in-first-table">
                <span
                  ><strong>DANE OSOBOWE / PERSONAL INFORMATION </strong></span
                >
              </p>
            </td>
            <td
              style="
                border: 1px solid;
                background-color: #a4c2f4;
                text-align: center;
              "
            >
              <p class="cell-in-first-table">
                <span><strong>DO WYPEŁNIENIA / FOR COMPLETION</strong></span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table"><span>Data / Date</span></p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{ aktualnaData() }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>Imiona i Nazwisko/ First and last name </span>
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{ imieNazwisko }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>Numer PESEL / PESEL number</span>
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{ pesel }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span
                  >Seria i numer dowodu osobistego (proszę podać w przypadku
                  braku nr PESEL)/ID card series and number (please specify if
                  no PESEL number)</span
                >
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{ nrDowodu }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>Obywatelstwo / Nationality</span>
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{ obywatelstwo }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>Numer telefonu / Telephone number</span>
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{ nrTelefonu }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>Adres e-mail / E-Mail address</span>
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{ email }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>Adres zamieszkania</span>
                <br />
                <span class="caption">
                  (ulica, nr domu, kod pocztowy, miejscowość)</span
                >
                <br />
                <span>Address of residence</span>
                <br />
                <span class="caption">
                  (street, house number, postal code, city)</span
                >
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table bigCell">
                <span>{{ zamieszkany }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>Adres korespondencyjny</span>
                <br />
                <span class="caption">
                  (ulica, nr domu, kod pocztowy, miejscowość)</span
                >
                <br />
                <span>Correspondence address</span>
                <br />
                <span class="caption">
                  (street, house number, postal code, city)</span
                >
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{ korespondencyjny }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>Urząd Skarbowy</span>
                <br />
                <span>(zgodny z adresem zamieszkania)</span>
                <br />
                <span>Tax office</span>
                <br />
                <span>(consistent with the address of residence)</span>
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table bigCell">
                <span>{{ urzadSkarbowy }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>Numer rachunku bankowego / Bank account number</span>
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{ nrRachunku }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td
              style="
                border: 1px solid;
                background-color: #a4c2f4;
                text-align: center;
              "
            >
              <p class="cell-in-first-table">
                <span><strong>OŚWIADCZAM, ŻE: / I DECLARE THAT:</strong></span>
              </p>
            </td>
            <td
              style="
                border: 1px solid;
                background-color: #a4c2f4;
                text-align: center;
              "
            >
              <p class="cell-in-first-table">
                <span
                  ><strong
                    >ODPOWIEDZI: „TAK” lub „NIE”<br />(lub opis, jeśli jest
                    wymagany) / ANSWER: "YES" or "NO"<br />(or description if
                    required)</strong
                  ></span
                >
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>1. Jestem emerytem / I am a pensioner</span>
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{ emeryt }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>2. Jestem rencistą / I am a disability pensioner</span>
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{ rencista }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span
                  >3. Posiadam orzeczenie o stopniu niepełnosprawności / I have
                  a disability certificate</span
                >
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{ orzeczenieNiepelnosprawnosc }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span
                  >3.1. Jeśli wpisano "TAK", proszę określić orzeczony stopień
                  niepełnosprawności / If "YES", please specify the degree of
                  disability</span
                >
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{
                  stopienNiepelnosprawnosc.replace(/\s*\(.*$/, "")
                }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span
                  >4. Jestem uczniem/studentem do 26 roku życia (jeśli wpisano
                  "TAK", proszę pominąć pkt. 5,6,7) / I am a junior
                  student/student under 26 years of age (if entered "YES",
                  please skip points 5,6,7
                </span>
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{ student }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span
                  >5. Wnoszę o dobrowolne ubezpieczenie chorobowe (tylko w
                  przypadku objęcia ubezpieczeniem emerytalnym i rentowym)/I
                  apply for voluntary sickness insurance (only if covered by
                  pension and disability insurance)</span
                >
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{ chorobowe.replace(/\s*\(.*$/, "") }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span
                  >6. Jestem zatrudniony/a na umowę o pracę lub umowę
                  zlecenie<br />(Jeśli wpisano "TAK", proszę uzupełnić poniższe
                  dane) / I am employed under an employment contract / I am
                  employed under an employment contract or a contract of mandate
                  (If "YES" is entered, please complete the following data)
                </span>
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{ zatrudnionyUmowaPraca.replace(/\s*\(.*$/, "") }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span
                  >6.1. Nazwa i adres pracodawcy/ Name and address of
                  employer</span
                >
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{ nazwaUmowaPraca }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span
                  >6.2. Wynagrodzenie z tytułu umowy o pracę/umowy zlecenie<br />jest
                  wyższe bądź równe krajowej płacy minimalnej / The salary under
                  the employment contract / contract of mandate is higher than
                  or equal to the national minimum wage</span
                >
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{
                  wynagrodzenieUmowaPraca.replace(/\s*\(.*$/, "")
                }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span
                  >7. Podlegam ubezpieczeniu społecznemu z innego tytułu<br />niż
                  umowa o pracę i/lub umowa cywilno-prawna z Tutore Poland Sp. z
                  o.o. / I am subject to social insurance under another title
                  than employment contract and/or civil contract with Tutore
                  Poland Sp. z o.o.</span
                >
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{ ubezpieczenieUmowaPraca }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span
                  >7.1. W przypadku odpowiedzi: TAK, proszę określić tytuł
                  ubezpieczenia / In case of the answer: is YES, please specify
                  the title of the insurance</span
                >
              </p>
            </td>
            <td style="border: 1px solid">
              <p class="cell-in-first-table">
                <span>{{ tytulUbezpieczenieUmowaPraca }}</span>
              </p>
            </td>
          </tr>

          <tr>
            <td
              colspan="2"
              style="
                border: 1px solid;
                background-color: #a4c2f4;
                text-align: center;
                font-size: 10px;
              "
            >
              <p class="cell-in-first-table">
                <span
                  ><strong>
                    Wypełnienie powyższego oświadczenia oznacza deklarację
                    zgodności wypisanych danych ze stanem prawnym oraz
                    faktycznym,oraz świadomość odpowiedzialności karnej za
                    zeznanie nieprawdy lub zatajenie prawdy.
                    <br />
                    Zobowiązuję się do poinformowania Pracodawcy w przypadku
                    zmiany ww. danych w terminie 7 dni od daty zaistnienia
                    zmiany. Wyrażam zgodę na podanie Administratorowi danych
                    osobowych mojego numeru telefonu, adresu e-mail i adresu do
                    korespondencji w Oświadczeniu Zleceniobiorcy, celem wysyłki
                    rocznych deklaracji rozliczeniowych.
                    <br /> </strong
                ></span>
              </p>
              <p class="cell-in-first-table">
                <span
                  ><strong>
                    Completion of the above declaration means the declaration of
                    compliance of the extracted data with the legal and factual
                    state, and awareness of the criminal liability for giving
                    false testimony or concealing the truth.
                    <br />
                    I undertake to inform the Employer in the event of a change
                    of the above data within 7 days from the date of the change.
                    I agree to provide the Administrator of the personal data
                    with my telephone number, e-mail address, and mailing
                    address in the Contractor's Statement to send annual
                    settlement declarations.
                    <br /> </strong
                ></span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <table>
      <tbody>
        <tr>
          <td class="polish">
            <div style="margin-top: 5px; page-break-before: always">
              <p style="margin-bottom: 0px">
                <b
                  >Załącznik nr 7. OGÓLNE ZASADY BHP PRZY PRACY
                  ADMINISTRACYJNO-BIUROWEJ</b
                >
              </p>
              <br />
              <p>Bezpieczne warunki pracy są zapewnione, gdy:</p>
              <ul>
                <li>
                  Zapewniona jest dostatecznie duża powierzchnia stanowiska
                  pracy (co najmniej 2m wolnej powierzchni podłogi).
                </li>
                <li>
                  Jest właściwe oświetlenie (w zależności od charakteru pracy
                  min. 300lx).
                </li>
                <li>
                  Jest dostateczna wentylacja pomieszczenia (naturalna lub
                  mechaniczna); wilgotność względna powietrza nie powinna być
                  mniejsza niż 40%.
                </li>
                <li>
                  Jest wystarczające ogrzewanie w okresie jesienno-zimowym (min.
                  +18°C)
                </li>
                <li>
                  Są dostępne i w dobrym stanie urządzenia higieniczno-sanitarne
                  oraz dobry stan techniczny mebli, sprzętu i innych urządzeń.
                </li>
              </ul>
              <p>
                Podstawowe czynności, które należy wykonać przed rozpoczęciem
                pracy:
              </p>
              <ul>
                <li>
                  Zaplanować kolejność wykonywania poszczególnych czynności,
                  przygotować potrzebne dokumenty i programy.
                </li>
                <li>
                  Ustawić ekran monitora względem źródeł światła tak, aby
                  ograniczyć olśnienie i odbicia światła.
                </li>
                <li>
                  Sprawdzić stan techniczny mebli, sprzętu, urządzeń, stan
                  oświetlenia stanowiska pracy.
                </li>
                <li>
                  Zaznajomić się dokładnie z instrukcją obsługi i instrukcją
                  bezpiecznej pracy sprzętu elektrycznego i elektronicznego
                  używanego w trakcie wykonywania pracy (komputer, drukarka,
                  itp.).
                </li>
                <li>
                  Odpowiednio dla siebie dopasować krzesło i przygotować
                  stanowisko pracy.
                </li>
              </ul>
              <p>Czynności, które należy wykonywać podczas pracy:</p>
              <ul>
                <li>Utrzymywać ład i porządek na stanowisku pracy.</li>
                <li>
                  Zachowywać ostrożność przy używaniu urządzeń elektrycznych.
                </li>
              </ul>
              <p>Czynności zabronione:</p>
              <ul>
                <li>
                  Dopuszczenia do użytkowania urządzeń osób nieupoważnionych.
                </li>
                <li>Otwierania osłon podczas pracy urządzeń.</li>
                <li>
                  Używania niesprawnych bądź uszkodzonych urządzeń, względnie
                  instalacji elektrycznej (np. zniszczona izolacja na
                  przewodach, stłuczone wtyczki lub gniazdka, prowizorycznie
                  połączone przewody).
                </li>
              </ul>
              <p>Uwagi końcowe:</p>
              <ul>
                <li>
                  Przy stałej pracy przy komputerze należy:
                  <ul>
                    <li>
                      łączyć przemiennie prace związana z obsługą monitora
                      ekranowego z innymi rodzajami prac nie obciążającymi
                      narządu wzroku i wykonywanymi w innych pozycjach ciała –
                      przy nieprzekraczaniu 1 godziny nieprzerwanej pracy przy
                      obsłudze monitora ekranowego lub
                    </li>
                    <li>
                      co najmniej 5-minutową przerwę, wliczaną do czasu pracy,
                      po każdej godzinie pracy przy obsłudze monitora
                      ekranowego.
                    </li>
                  </ul>
                </li>
              </ul>
              <p style="margin-top: 30px">
                Oświadczam, iż zapoznałem się i akceptuję powyższa zasady bhp
                przy pracy administracyjno-biurowej.
              </p>
              <div style="float: right; margin-top: 40px; font-size: 10px">
                <p style="font-size: 14px; margin-bottom: 0">
                  {{ imieNazwisko }}
                </p>
                <p style="font-size: 14px">Podpis Zleceniobiorcy</p>
              </div>
            </div>
          </td>
          <td class="english">
            <div style="margin-top: 5px; page-break-before: always">
              <p style="margin-bottom: 0px">
                <b
                  >Attachment No. 7 GENERAL PRINCIPLES OF HEALTH AND SAFETY IN
                  ADMINISTRATIVE AND OFFICE WORK</b
                >
              </p>
              <br />
              <p>Safe working conditions are ensured when:</p>
              <ul>
                <li>
                  A sufficiently large workstation area is provided (at least 2m
                  free floor space).
                </li>
                <li>
                  There is adequate lighting (depending on the nature of the
                  work at least 300lx).
                </li>
                <li>
                  There is sufficient ventilation of the room (natural or
                  mechanical); the relative humidity of the air should not be
                  less than 40%.
                </li>
                <li>
                  There is sufficient heating in autumn and winter (min. +18°C).
                </li>
                <li>
                  Hygienic and sanitary facilities are available and in good
                  condition, and furniture, equipment and other appliances are
                  in good working order.
                </li>
              </ul>
              <p>Basic steps to be taken before starting work:</p>
              <ul>
                <li>
                  Plan the order in which to carry out the various activities,
                  prepare the necessary documents and programmes.
                </li>
                <li>
                  Position the monitor screen in relation to light sources so as
                  to reduce glare and reflections.
                </li>
                <li>
                  Check the technical condition of furniture, equipment,
                  appliances, lighting condition of the workstation.
                </li>
                <li>
                  Familiarise themselves thoroughly with the operating
                  instructions and safe working instructions of the electrical
                  and electronic equipment used in the course of work (computer,
                  printer, etc.).
                </li>
                <li>
                  Fit a chair appropriately for yourself and prepare a
                  workstation.
                </li>
              </ul>
              <p>Activities to be performed during work:</p>
              <ul>
                <li>Maintain order and tidiness at the workstation.</li>
                <li>Be careful when using electrical equipment.</li>
              </ul>
              <p>Prohibited activities:</p>
              <ul>
                <li>Allowing unauthorised persons to use equipment.</li>
                <li>Opening covers during operation.</li>
                <li>
                  Use of faulty or damaged devices or wiring (e.g. damaged
                  insulation on cables, broken plugs or sockets, temporary
                  wiring).
                </li>
              </ul>
              <p>Concluding remarks:</p>
              <ul>
                <li>
                  When working permanently at a computer, one should:
                  <ul>
                    <li>
                      alternate between work involving the use of a screen
                      monitor and other work that does not strain the eyes and
                      that is carried out in other postures - not exceeding 1
                      hour of uninterrupted work at a screen monitor or
                    </li>
                    <li>
                      a break of at least 5 minutes, counted as working time,
                      after each hour of work at a screen monitor.
                    </li>
                  </ul>
                </li>
              </ul>
              <p style="margin-top: 30px">
                I declare that I have read and accept the above rules of health
                and safety at administrative and office work.
              </p>
              <div style="float: right; margin-top: 40px; font-size: 10px">
                <p style="font-size: 14px; margin-bottom: 0">
                  {{ imieNazwisko }}
                </p>
                <p style="font-size: 14px">
                  legible signature of the Contractor
                </p>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </v-container>
</template>
  
  <script>
export default {
  name: "UmowaZlecenieProfiAngielski2023",
  data() {
    return {
      zamawiajacy: "",
      imieNazwisko: "",
      zamieszkany: "",
      korespondencyjny: "",
      pesel: "",
      nrRachunku: "",
      nrDowodu: "",
      nrTelefonu: "",
      email: "",
      emeryt: "",
      rencista: "",
      orzeczenieNiepelnosprawnosc: "",
      stopienNiepelnosprawnosc: "",
      student: "",
      jedenyTytulDoUbezpieczenia: "",
      chorobowe: "",
      zatrudnionyUmowaPraca: "",
      nazwaUmowaPraca: "",
      wynagrodzenieUmowaPraca: "",
      ubezpieczenieUmowaPraca: "",
      tytulUbezpieczenieUmowaPraca: "",
      umowaOd: "",
      umowaDo: "",
      urzadSkarbowy: "",
      nrUmowy: "",
      datapocz: "",
      datakon: "",
      wypo: "",
      kwotapokaz: "",
      slowniepokaz: "",
      shortUmowa: "",
      obywatelstwo: "",
      stawka1: "",
      stawka2: "",
      stawka3: "",
    };
  },
  created() {
    Object.entries(this.$route.query).forEach(([key, value]) => {
      this[key] = value;
    });
  },
  methods: {
    shortNrUmowy() {
      let tab = [];
      let shortPosition = "";
      tab = this.nrUmowy.split("/");
      switch (tab[3]) {
        case "Nauczyciel":
          shortPosition = "Nau";
          break;
        case "Metodyk":
          shortPosition = "Met";
          break;
        case "TworcaMaterialow":
          shortPosition = "TMat";
          break;
        case "TworcaMaterialowNauczycielMetodyk":
          shortPosition = "TMatNauMet";
          break;
        case "TworzenieProgramuNauczania":
          shortPosition = "TPNau";
          break;
        case "AsystentOrganizacyjny":
          shortPosition = "AOrg";
          break;
        case "MłodszyAsystentOrganizacyjny":
          shortPosition = "MAOrg";
          break;
        case "TworzenieMap":
          shortPosition = "TMapMC";
          break;
        default:
          shortPosition = tab[3];
      }
      const shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/${shortPosition}`;
      return shortUmowa;
    },
    slownieAngielski() {
      switch (this.kwota) {
        case "25":
          return "twenty-five";
          break;
        case "30":
          return "thirty";
          break;
        case "35":
          return "thirty-five";
          break;
        case "40":
          return "forty";
          break;
        case "45":
          return "forty-five";
          break;
        case "50":
          return "fifty";
          break;
        case "55":
          return "fifty-five";
          break;
        case "60":
          return "sixty";
          break;
        case "65":
          return "sixty-five";
          break;
        case "70":
          return "seventy";
          break;
        case "75":
          return "seventy-five";
          break;
        case "80":
          return "eighty";
          break;
        case "85":
          return "eighty-five";
          break;
        case "90":
          return "ninety";
          break;
        case "95":
          return "ninety-five";
          break;
        default:
          return this.slownie;
      }
    },
    slowniePokazAngielski() {
      switch (this.kwotapokaz) {
        case "25":
          return "twenty-five";
          break;
        case "30":
          return "thirty";
          break;
        case "35":
          return "thirty-five";
          break;
        case "40":
          return "forty";
          break;
        case "45":
          return "forty-five";
          break;
        case "50":
          return "fifty";
          break;
        case "55":
          return "fifty-five";
          break;
        case "60":
          return "sixty";
          break;
        case "65":
          return "sixty-five";
          break;
        case "70":
          return "seventy";
          break;
        case "75":
          return "seventy-five";
          break;
        case "80":
          return "eighty";
          break;
        case "85":
          return "eighty-five";
          break;
        case "90":
          return "ninety";
          break;
        case "95":
          return "ninety-five";
          break;
        default:
          return this.slowniepokaz;
      }
    },
    dataObowiazywaniaUmowyPolski() {
      if (this.umowaOd === "" || this.umowaOd === "30-12-1899") {
        return "podpisania umowy przez obie strony";
      } else {
        return `${this.umowaOd} r.`;
      }
    },
    dataKoncaUmowyPolski() {
      if (this.umowaDo === "" || this.umowaDo === "30-12-1899") {
        return "31-08-2023";
      } else {
        return `${this.umowaDo} r.`;
      }
    },
    dataObowiazywaniaUmowyAngielski() {
      if (this.umowaOd === "" || this.umowaOd === "30-12-1899") {
        return "of signature of the contract by both parties";
      } else {
        return `${this.umowaOd} r.`;
      }
    },
    dataKoncaUmowyAngielski() {
      if (this.umowaDo === "" || this.umowaDo === "30-12-1899") {
        return "31-08-2023";
      } else {
        return `${this.umowaDo} r.`;
      }
    },
    zamawiajacyAngielski() {
      if (this.zamawiajacy === "Marcin Grzelak - Prezes Zarządu") {
        return "Marcin Grzelak - CEO";
      } else {
        return this.zamawiajacy;
      }
    },
    aktualnaData() {
      const today = new Date();
      let day = today.getDate();
      if (day + 1 <= 10) {
        day = "0" + day;
      }
      let month = today.getMonth() + 1;
      if (today.getMonth() + 1 < 10) {
        month = "0" + month;
      }
      const todayDate = day + "-" + month + "-" + today.getFullYear();
      return todayDate;
    },
  },
  mounted() {
    if (this.zamawiajacy) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href;
          history.replaceState(history.state, "", "/");
          window.print();
          history.replaceState(history.state, "", currentURL);
        }, 300);
      });
    }
  },
};
</script>
  
  <style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}

table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
}

th,
td {
  border: 1px;
  border-collapse: collapse;
}

.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.cointainer-left {
  width: 20%;
}

.right-cointainer {
  text-align: end;
}

thead {
  display: table-header-group;
}

.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}

.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}

ul.dashed {
  list-style-type: "- ";
  margin: 0;
}

.underline {
  text-decoration: underline;
}

.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}

#oswiadczenie {
  padding: 20px;
}

.p-margin {
  margin-bottom: 5px !important;
}

.polish {
  width: 51%;
}

.english {
  width: 50%;
  padding-left: 15px;
}

.attachments {
  width: 100%;
}
</style>
  


// WEBPACK FOOTER //
// src/components/UmowaLektorAngielski2023.vue